(function () {
  'use strict';
  // TCB_PACKAGES_BUILD=2026-08-07-r8-r19-intelligence-stack

  var CATEGORY_LABELS = {
    'ready-made': 'Ready-Made',
    facility: 'By Facility',
    starter: 'Starter'
  };

  var FINDER_MAP = {
    contractor: ['contractor-facility', 'trusted-clean-maximum-contractor', 'mytee-2008cs-extractor'],
    office: ['cleanfreak-17-scrubber', 'cleanfreak-performer-20'],
    school: ['school-facility', 'cleanfreak-17-scrubber'],
    gym: ['cleanfreak-performer-20', 'floor-scrubber-starter'],
    restaurant: ['cleanfreak-17-scrubber', 'cleanfreak-performer-20'],
    warehouse: ['warehouse-facility', 'cleanfreak-performer-20'],
    hotel: ['hotel-facility', 'mytee-2008cs-extractor'],
    healthcare: ['healthcare-facility', 'cleanfreak-17-scrubber'],
    startup: ['starter-business', 'carpet-extractor-starter', 'floor-scrubber-starter']
  };

  var PRICE_HINTS = {
    'ready-made': 'From $2,999',
    facility: 'From $4,999',
    starter: 'From $2,499'
  };

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function packageAnalyticsContext(section, pageData) {
    return {
      package_id: (pageData && (pageData.id || pageData.package_id)) || (section && section.getAttribute('data-package-id')) || '',
      facility_id: (pageData && pageData.facility_id) || (section && section.getAttribute('data-facility-id')) || '',
      package_type: (pageData && pageData.type) || (section && section.getAttribute('data-package-type')) || '',
      tier: (pageData && pageData.tier) || '',
      page_handle: (section && section.getAttribute('data-page-handle')) || (pageData && pageData.page_handle) || ''
    };
  }

  function trackPackageEvent(method, section, pageData, extra) {
    if (!window.tcbAnalytics || typeof window.tcbAnalytics[method] !== 'function') return;
    window.tcbAnalytics[method](Object.assign(packageAnalyticsContext(section, pageData), extra || {}));
  }

  function bindPackageAnalytics(section, pageData) {
    if (!section || section.getAttribute('data-tcb-analytics-bound') === '1') return;
    section.setAttribute('data-tcb-analytics-bound', '1');
    section.__tcbPageData = pageData || null;
    trackPackageEvent('packageViewed', section, pageData);

    section.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var quote = target.closest('a[href*="topic=equipment-package"], a[href*="/pages/contact"], [data-tcb-package-quote-primary], .tcb-pkg-included-v3__quote-link');
      if (quote) {
        trackPackageEvent('packageQuoteClicked', section, section.__tcbPageData);
        return;
      }
      var advisor = target.closest('a[href*="cleaning-equipment-advisor"], a[href*="equipment-finder"]');
      if (advisor) {
        trackPackageEvent('packageAiAdvisorClick', section, section.__tcbPageData);
        return;
      }
      var product = target.closest('a[href*="/products/"]');
      if (product) {
        trackPackageEvent('packageProductClick', section, section.__tcbPageData, {
          product_url: product.getAttribute('href') || ''
        });
        return;
      }
      var related = target.closest('.tcb-pkg-complete a[href*="/pages/package-"], .tcb-packages-card');
      if (related) {
        trackPackageEvent('packageRelatedPackageClick', section, section.__tcbPageData, {
          related_url: related.getAttribute('href') || ''
        });
        return;
      }
      var guide = target.closest('a[href*="parts-finder"], a[href*="manual-finder"], a[href*="video-library"], a[href*="financing"]');
      if (guide) {
        trackPackageEvent('packageGuideClick', section, section.__tcbPageData, {
          guide_url: guide.getAttribute('href') || ''
        });
      }
    });

    bindPackageVideoTrigger(section);
  }

  function resolvePackageVideo(pageData) {
    if (!pageData || typeof pageData !== 'object') return null;
    var content = pageData.content || {};
    var pipe =
      (pageData.production && pageData.production.video_pipeline) ||
      (pageData.intelligence && pageData.intelligence.video && pageData.intelligence.video.pipeline) ||
      (pageData.procedure && pageData.procedure.video && pageData.procedure.video.pipeline) ||
      null;
    var url = pageData.video_url || content.video_url || pageData.creatify_video_url || '';
    var status = String(
      (pageData.production && pageData.production.video_status) ||
        pageData.video_status ||
        content.video_status ||
        (url ? 'ready' : 'planned')
    ).toLowerCase();
    var provider = pageData.video_provider || content.video_provider || 'creatify';
    var id =
      pageData.creatify_video_id ||
      content.creatify_video_id ||
      (pageData.intelligence && pageData.intelligence.r9_video_id) ||
      pageData.video_id ||
      '';
    var thumbnail = pageData.video_thumbnail || content.video_thumbnail || pageData.hero_image_asset || '';
    // Wave 4/5 honesty: ready only when all four gates pass (or legacy ready+url)
    var packageReady = !!(
      pipe &&
      pipe.script_ready &&
      pipe.render_ready &&
      pipe.qa_passed &&
      pipe.package_attached &&
      pipe.package_ready
    );
    var ready = packageReady || (status === 'ready' && !!String(url || '').trim());
    if (!ready && (status === 'ready' || status === 'published' || status === 'complete')) {
      status = pipe && pipe.script_ready ? 'script_ready' : 'planned';
    }
    return {
      url: String(url || '').trim(),
      status: status,
      provider: provider,
      id: String(id || '').trim(),
      thumbnail: String(thumbnail || '').trim(),
      ready: ready,
      pipeline: pipe,
      script_ready: !!(pipe && pipe.script_ready) || status === 'script_ready'
    };
  }

  function ensurePackageVideoModal() {
    var existing = document.getElementById('tcb-package-video-modal');
    if (existing) return existing;
    var modal = document.createElement('div');
    modal.id = 'tcb-package-video-modal';
    modal.className = 'tcb-package-video-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Package video');
    modal.innerHTML =
      '<div class="tcb-package-video-modal__backdrop" data-tcb-package-video-close></div>' +
      '<div class="tcb-package-video-modal__dialog">' +
        '<button type="button" class="tcb-package-video-modal__close" data-tcb-package-video-close aria-label="Close video">&times;</button>' +
        '<div class="tcb-package-video-modal__body" data-tcb-package-video-body></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-tcb-package-video-close]')) closePackageVideoModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closePackageVideoModal();
    });
    return modal;
  }

  function closePackageVideoModal() {
    var modal = document.getElementById('tcb-package-video-modal');
    if (!modal) return;
    var body = modal.querySelector('[data-tcb-package-video-body]');
    if (body) body.innerHTML = '';
    modal.hidden = true;
    document.body.classList.remove('tcb-package-video-open');
  }

  function openPackageVideoModal(video, pageData) {
    var modal = ensurePackageVideoModal();
    var body = modal.querySelector('[data-tcb-package-video-body]');
    if (!body) return;
    var title = (pageData && (pageData.page_title || pageData.title)) || 'Package walkthrough';
    if (video && video.ready && video.url) {
      var url = video.url;
      var isMp4 = /\.mp4($|\?)/i.test(url) || /creatify|cdn\.|cloudinary|mux/i.test(url);
      var isEmbed = /youtube\.com|youtu\.be|vimeo\.com|player\./i.test(url);
      if (isEmbed && /watch\?v=/.test(url)) {
        url = url.replace('watch?v=', 'embed/').split('&')[0];
      } else if (isEmbed && /youtu\.be\//.test(url)) {
        url = url.replace('youtu.be/', 'youtube.com/embed/');
      }
      if (isEmbed || /\/embed\//i.test(url)) {
        body.innerHTML =
          '<iframe class="tcb-package-video-modal__frame" src="' + escapeHtml(url) +
          '" title="' + escapeHtml(title) +
          '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      } else {
        body.innerHTML =
          '<video class="tcb-package-video-modal__frame" controls autoplay playsinline' +
          (video.thumbnail ? ' poster="' + escapeHtml(video.thumbnail) + '"' : '') +
          ' src="' + escapeHtml(url) + '"></video>';
      }
    } else {
      body.innerHTML =
        '<div class="tcb-package-video-modal__pending">' +
          '<p class="tcb-package-video-modal__pending-kicker">Creatify video</p>' +
          '<h3>Walkthrough coming soon</h3>' +
          '<p>' +
            (video && video.script_ready
              ? 'A package walkthrough script is ready from the Complete Package Description and approved procedure. The rendered Creatify video will play here after QA publish — scripts alone are not marked package-ready.'
              : 'This package hero will play a Creatify-generated walkthrough as soon as the video URL is published for this page.') +
          '</p>' +
        '</div>';
    }
    modal.hidden = false;
    document.body.classList.add('tcb-package-video-open');
  }

  function bindPackageVideoTrigger(section) {
    if (!section || section.getAttribute('data-tcb-video-bound') === '1') return;
    var videoBtn = section.querySelector('[data-tcb-package-video-trigger]');
    if (!videoBtn) return;
    section.setAttribute('data-tcb-video-bound', '1');
    videoBtn.hidden = false;
    videoBtn.setAttribute('data-tcb-video-provider', 'creatify');
    videoBtn.addEventListener('click', function () {
      var pageData = section.__tcbPageData || null;
      var video = resolvePackageVideo(pageData);
      trackPackageEvent('packageVideoPlay', section, pageData, {
        video_provider: (video && video.provider) || 'creatify',
        video_status: (video && video.status) || 'planned',
        video_ready: !!(video && video.ready)
      });
      openPackageVideoModal(video, pageData);
    });
  }

  function getPackageTermsConfig(source) {
    source = source || null;
    var legacyPrefix = source && source.getAttribute('data-included-terms-prefix');
    var defaultLabel = legacyPrefix
      ? legacyPrefix + ' Terms & Conditions'
      : 'I agree to the Package Terms & Conditions. Package purchases are final sale and are not eligible for return or refund.';
    return {
      label: (source && source.getAttribute('data-included-terms-label')) || defaultLabel,
      note: (source && source.getAttribute('data-included-terms-note')) ||
        'Some package items may ship separately. Large equipment may require freight delivery. If an item is unavailable, our team may contact you before fulfillment or recommend an equivalent replacement.',
      policies: [
        {
          url: (source && source.getAttribute('data-included-terms-url')) || '/pages/package-terms',
          text: (source && source.getAttribute('data-included-terms-link')) || 'Terms & Conditions'
        },
        {
          url: (source && source.getAttribute('data-included-shipping-url')) || '/pages/shipping',
          text: (source && source.getAttribute('data-included-shipping-link')) || 'Shipping Policy'
        },
        {
          url: (source && source.getAttribute('data-included-returns-url')) || '/pages/returns',
          text: (source && source.getAttribute('data-included-returns-link')) || 'Return Policy'
        },
        {
          url: (source && source.getAttribute('data-included-warranty-url')) || '/pages/warranty',
          text: (source && source.getAttribute('data-included-warranty-link')) || 'Warranty Policy'
        }
      ]
    };
  }

  function renderPackagePolicyLinks(policies) {
    return policies.map(function (policy, index) {
      return (index ? ' · ' : '') +
        '<a href="' + escapeHtml(policy.url) + '" target="_blank" rel="noopener noreferrer">' +
        escapeHtml(policy.text) +
        '</a>';
    }).join('');
  }

  function renderPackageTermsBlock(config, wrapperClass, termsClass, options) {
    wrapperClass = wrapperClass || 'tcb-package-terms';
    termsClass = termsClass || 'tcb-pkg-included-v3__terms';
    options = options || {};
    return (
      '<div class="' + escapeHtml(wrapperClass) + '">' +
        '<label class="tcb-pkg-checkout-v4__terms ' + escapeHtml(termsClass) + '">' +
          '<input type="checkbox" data-tcb-package-terms>' +
          '<span class="tcb-package-terms__copy">' +
            '<span class="tcb-package-terms__text">' + escapeHtml(config.label) + '</span>' +
            '<span class="tcb-package-terms__links">' + renderPackagePolicyLinks(config.policies) + '</span>' +
          '</span>' +
        '</label>' +
        (options.compact ? '' : '<p class="tcb-package-terms__note">' + escapeHtml(config.note) + '</p>') +
      '</div>'
    );
  }

  function pageUrl(pkg) {
    return '/pages/package-' + encodeURIComponent(pkg.id);
  }

  function readShopProducts(section) {
    var node = section.querySelector('[data-tcb-shop-products]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function shopProductByHandle(shopProducts, handle) {
    if (!handle) return null;
    return shopProducts.find(function (product) { return product.handle === handle; }) || null;
  }

  function formatFinance(priceCents) {
    if (!priceCents) return '';
    var monthly = Math.max(99, Math.round(Number(priceCents) / 12 / 100));
    return 'As low as $' + monthly + '/mo*';
  }

  function renderProductMedia(image, alt, className) {
    if (image) {
      var seoAlt = alt || 'Commercial cleaning equipment package photo';
      return '<img class="' + className + '" src="' + escapeHtml(image) + '" alt="' + escapeHtml(seoAlt) + '" loading="lazy" width="280" height="180" decoding="async">';
    }
    return '<span class="' + className + ' ' + className + '--fallback" aria-hidden="true">📦</span>';
  }

  function packageSeoAlt(title, context) {
    var base = String(title || 'Commercial cleaning equipment').trim();
    if (!base) base = 'Commercial cleaning equipment';
    if (context === 'included') return base + ' — package equipment overview photo';
    if (context === 'bundle') return base + ' — commercial cleaning product photo';
    if (context === 'hero') return 'Commercial cleaning equipment package hero: ' + base;
    return base + ' — commercial cleaning equipment photo';
  }

  var SIZE_LABELS = {
    starter: 'Up to 10,000 sq ft',
    'ready-made': '10,000 – 50,000 sq ft',
    facility: '50,000 – 100,000 sq ft'
  };

  function buildBrowseItems(catalog, shopProducts, preferCollection) {
    var items = [];
    var usedHandles = {};

    (catalog.packages || []).forEach(function (pkg) {
      var product = pkg.product_handle ? shopProductByHandle(shopProducts, pkg.product_handle) : null;
      items.push({
        id: pkg.id,
        kind: product ? 'product' : 'page',
        title: product ? product.title : pkg.title,
        tagline: pkg.tagline || (product && product.vendor ? product.vendor : ''),
        category: pkg.category,
        featured: !!pkg.featured,
        menu_order: pkg.menu_order || 99,
        url: pkg.category === 'ready-made' ? pageUrl(pkg) : (product ? product.url : pageUrl(pkg)),
        product_handle: pkg.product_handle || null,
        package_page_id: pkg.package_page_id || null,
        cart_items: pkg.cart_items || null,
        price_label: product ? product.price_formatted : (PRICE_HINTS[pkg.category] || 'Custom quote'),
        finance_label: product ? formatFinance(product.price) : '',
        size_label: SIZE_LABELS[pkg.category] || '',
        image: product ? product.image : null,
        image_alt: product ? product.image_alt : pkg.title,
        available: product ? product.available !== false : null
      });
      if (product) usedHandles[product.handle] = true;
    });

    if (preferCollection) {
      shopProducts.forEach(function (product) {
        if (usedHandles[product.handle]) return;
        items.push({
          id: product.handle,
          kind: 'product',
          title: product.title,
          tagline: product.vendor || 'Equipment package',
          category: 'ready-made',
          featured: false,
          menu_order: 100,
          url: product.url,
          price_label: product.price_formatted,
          finance_label: formatFinance(product.price),
          size_label: 'Custom facility fit',
          image: product.image,
          image_alt: product.image_alt
        });
      });
    }

    return items;
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-tcb-tab]');
    var panels = root.querySelectorAll('[data-tcb-panel]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tcb-tab');
        tabs.forEach(function (el) {
          var active = el === tab;
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var match = panel.getAttribute('data-tcb-panel') === id;
          panel.classList.toggle('is-active', match);
          panel.hidden = !match;
        });
      });
    });
  }

  function renderPopularCard(pkg, shopProducts, highlightIds) {
    var isMatch = !highlightIds || highlightIds.indexOf(pkg.id) !== -1;
    var product = pkg.product_handle ? shopProductByHandle(shopProducts, pkg.product_handle) : null;
    var badge = pkg.featured ? 'BEST SELLER' : 'PACKAGE';
    var href = pkg.category === 'ready-made' ? pageUrl(pkg) : (product ? product.url : pageUrl(pkg));
    var title = product ? product.title : pkg.title;
    var price = product ? product.price_formatted : (PRICE_HINTS[pkg.category] || 'Request quote');
    var finance = product ? formatFinance(product.price) : formatFinance(parseInt(String(PRICE_HINTS[pkg.category] || '').replace(/\D/g, ''), 10) * 100);
    var isReadyMade = pkg.category === 'ready-made' && pkg.product_handle;

    if (isReadyMade) {
      return (
        '<article class="tcb-packages-popular-card tcb-packages-popular-card--shop' + (isMatch && highlightIds ? ' is-recommended' : '') + '" data-package-id="' + escapeHtml(pkg.id) + '">' +
          '<a class="tcb-packages-popular-card__link" href="' + escapeHtml(href) + '">' +
            '<div class="tcb-packages-popular-card__media">' +
              renderProductMedia(product && product.image, product ? product.image_alt : title, 'tcb-packages-popular-card__img') +
            '</div>' +
            '<div class="tcb-packages-popular-card__top">' +
              '<span class="tcb-packages-popular-card__badge">' + badge + '</span>' +
              '<span class="tcb-packages-popular-card__stars" aria-hidden="true">★★★★★</span>' +
            '</div>' +
            '<h3>' + escapeHtml(title) + '</h3>' +
            '<div class="tcb-packages-popular-card__pricing">' +
              '<p class="tcb-packages-popular-card__price">' + escapeHtml(price) + '</p>' +
              (finance ? '<p class="tcb-packages-popular-card__finance">' + escapeHtml(finance) + '</p>' : '') +
            '</div>' +
          '</a>' +
          '<div class="tcb-packages-popular-card__actions">' +
            '<a class="tcb-page-btn tcb-page-btn--secondary tcb-page-btn--wireframe tcb-page-btn--compact" href="' + escapeHtml(href) + '">View Package</a>' +
            '<button type="button" class="tcb-page-btn tcb-page-btn--package tcb-page-btn--wireframe tcb-page-btn--compact" data-tcb-catalog-add="' + escapeHtml(pkg.id) + '">Add Package to Cart</button>' +
          '</div>' +
        '</article>'
      );
    }

    return (
      '<a class="tcb-packages-popular-card' + (isMatch && highlightIds ? ' is-recommended' : '') + '" href="' + escapeHtml(href) + '" data-package-id="' + escapeHtml(pkg.id) + '">' +
        '<div class="tcb-packages-popular-card__media">' +
          renderProductMedia(product && product.image, product ? product.image_alt : title, 'tcb-packages-popular-card__img') +
        '</div>' +
        '<div class="tcb-packages-popular-card__top">' +
          '<span class="tcb-packages-popular-card__badge">' + badge + '</span>' +
          '<span class="tcb-packages-popular-card__stars" aria-hidden="true">★★★★★</span>' +
        '</div>' +
        '<h3>' + escapeHtml(title) + '</h3>' +
        '<div class="tcb-packages-popular-card__pricing">' +
          '<p class="tcb-packages-popular-card__price">' + escapeHtml(price) + '</p>' +
          (finance ? '<p class="tcb-packages-popular-card__finance">' + escapeHtml(finance) + '</p>' : '') +
        '</div>' +
        '<span class="tcb-page-btn tcb-page-btn--package tcb-page-btn--wireframe tcb-page-btn--compact">View Package</span>' +
      '</a>'
    );
  }

  function destroyPopularSlider(list) {
    if (!list) return;
    if (list._tcbPopularSliderStop) {
      list._tcbPopularSliderStop();
      list._tcbPopularSliderStop = null;
    }
    list.classList.remove('tcb-packages-popular__list--slider');
    var popular = list.closest('.tcb-packages-popular');
    if (popular) {
      var dots = popular.querySelector('[data-tcb-popular-dots]');
      if (dots) dots.remove();
    }
    list.querySelectorAll('.tcb-packages-popular-card').forEach(function (slide) {
      slide.classList.remove('is-active');
      slide.removeAttribute('aria-hidden');
    });
  }

  function initPopularSlider(list) {
    if (!list) return;

    var slides = list.querySelectorAll('.tcb-packages-popular-card');
    if (slides.length <= 1) return;

    list.classList.add('tcb-packages-popular__list--slider');
    list.setAttribute('role', 'region');
    list.setAttribute('aria-roledescription', 'carousel');

    var popular = list.closest('.tcb-packages-popular');
    var dotsContainer = popular && popular.querySelector('[data-tcb-popular-dots]');
    if (!dotsContainer && popular) {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'tcb-packages-popular__dots';
      dotsContainer.setAttribute('data-tcb-popular-dots', '');
      dotsContainer.setAttribute('role', 'tablist');
      dotsContainer.setAttribute('aria-label', 'Popular package slides');
      list.parentNode.insertBefore(dotsContainer, list.nextSibling);
    }

    var dots = [];
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      slides.forEach(function (_, idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'tcb-packages-popular__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Show package ' + (idx + 1));
        dot.addEventListener('click', function () {
          stopAuto();
          showSlide(idx);
          startAuto();
        });
        dotsContainer.appendChild(dot);
        dots.push(dot);
      });
    }

    var index = 0;
    var timer = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var intervalMs = reducedMotion ? 0 : 7000;

    function updateDots() {
      dots.forEach(function (dot, idx) {
        var active = idx === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function showSlide(i) {
      index = i;
      slides.forEach(function (slide, idx) {
        var active = idx === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.setAttribute('aria-roledescription', 'slide');
      });
      updateDots();
    }

    function next() {
      showSlide((index + 1) % slides.length);
    }

    function startAuto() {
      if (!intervalMs || slides.length <= 1) return;
      stopAuto();
      timer = window.setInterval(next, intervalMs);
    }

    function stopAuto() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    showSlide(0);
    startAuto();

    list.addEventListener('mouseenter', stopAuto);
    list.addEventListener('mouseleave', startAuto);
    list.addEventListener('focusin', stopAuto);
    list.addEventListener('focusout', function (event) {
      if (!list.contains(event.relatedTarget)) startAuto();
    });

    list._tcbPopularSliderStop = function () {
      stopAuto();
      list.removeEventListener('mouseenter', stopAuto);
      list.removeEventListener('mouseleave', startAuto);
      list.removeEventListener('focusin', stopAuto);
    };
  }

  function loadPopular(root, catalogUrl, shopProducts, highlightIds) {
    var list = root.querySelector('[data-tcb-popular-list]');
    if (!list || !catalogUrl) return;

    destroyPopularSlider(list);

    fetch(catalogUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var pkgs = (data.packages || []).slice();
        pkgs.sort(function (a, b) {
          return (a.menu_order || 99) - (b.menu_order || 99);
        });

        var featured = pkgs.filter(function (p) { return p.featured; });
        if (!featured.length) featured = pkgs.slice(0, 3);

        if (highlightIds && highlightIds.length) {
          var matched = pkgs.filter(function (p) { return highlightIds.indexOf(p.id) !== -1; });
          if (matched.length) {
            featured = matched.concat(featured.filter(function (p) {
              return highlightIds.indexOf(p.id) === -1;
            }));
          }
        }

        list.innerHTML = featured.slice(0, 3).map(function (pkg) {
          return renderPopularCard(pkg, shopProducts, highlightIds);
        }).join('');

        initPopularSlider(list);
      })
      .catch(function () {
        list.innerHTML = '<p class="tcb-packages-loading">Unable to load packages.</p>';
      });
  }

  function renderBrowseCard(item, categories) {
    var category = categories.find(function (c) { return c.id === item.category; });
    var categoryLabel = category ? category.label : (CATEGORY_LABELS[item.category] || item.category);
    var badges = '<span class="tcb-packages-card__badge">' + escapeHtml(categoryLabel) + '</span>';
    if (item.featured) {
      badges += '<span class="tcb-packages-card__badge tcb-packages-card__badge--featured">Featured</span>';
    }
    if (item.kind === 'product') {
      badges += '<span class="tcb-packages-card__badge tcb-packages-card__badge--shop">Shop now</span>';
    }

    if (item.category === 'ready-made' && item.product_handle) {
      return (
        '<article class="tcb-packages-card tcb-packages-card--shop' + (item.image ? ' tcb-packages-card--has-image' : '') + '">' +
          '<a class="tcb-packages-card__link" href="' + escapeHtml(item.url) + '">' +
            (item.image ? '<div class="tcb-packages-card__media tcb-packages-card__media--light">' + renderProductMedia(item.image, item.image_alt, 'tcb-packages-card__img') + '</div>' : '') +
            '<div class="tcb-packages-card__body">' +
              '<div class="tcb-packages-card__top">' + badges + '</div>' +
              '<h3>' + escapeHtml(item.title) + '</h3>' +
              (item.size_label ? '<p class="tcb-packages-card__meta">' + escapeHtml(item.size_label) + '</p>' : '') +
              '<p class="tcb-packages-card__stars" aria-hidden="true">★★★★★</p>' +
              '<p class="tcb-packages-popular-card__price">' + escapeHtml(item.price_label) + '</p>' +
              (item.finance_label ? '<p class="tcb-packages-popular-card__finance">' + escapeHtml(item.finance_label) + '</p>' : '') +
            '</div>' +
          '</a>' +
          '<div class="tcb-packages-card__actions">' +
            '<a class="tcb-page-btn tcb-page-btn--secondary tcb-page-btn--compact" href="' + escapeHtml(item.url) + '">View Package</a>' +
            '<button type="button" class="tcb-page-btn tcb-page-btn--package tcb-page-btn--compact" data-tcb-catalog-add="' + escapeHtml(item.id) + '">Add Package to Cart</button>' +
          '</div>' +
        '</article>'
      );
    }

    return (
      '<a class="tcb-packages-card' + (item.image ? ' tcb-packages-card--has-image' : '') + '" href="' + escapeHtml(item.url) + '">' +
        (item.image ? '<div class="tcb-packages-card__media tcb-packages-card__media--light">' + renderProductMedia(item.image, item.image_alt, 'tcb-packages-card__img') + '</div>' : '') +
        '<div class="tcb-packages-card__body">' +
          '<div class="tcb-packages-card__top">' + badges + '</div>' +
          '<h3>' + escapeHtml(item.title) + '</h3>' +
          (item.size_label ? '<p class="tcb-packages-card__meta">' + escapeHtml(item.size_label) + '</p>' : '') +
          '<p class="tcb-packages-card__stars" aria-hidden="true">★★★★★</p>' +
          '<p class="tcb-packages-popular-card__price">' + escapeHtml(item.price_label) + '</p>' +
          (item.finance_label ? '<p class="tcb-packages-popular-card__finance">' + escapeHtml(item.finance_label) + '</p>' : '') +
          '<span class="tcb-packages-card__link">View Package →</span>' +
        '</div>' +
      '</a>'
    );
  }

  function initBrowse(root, catalogUrl, shopProducts, preferCollection, presetsUrl, cartState) {
    var grid = root.querySelector('[data-tcb-packages-grid]');
    var countEl = root.querySelector('[data-tcb-packages-count]');
    var emptyEl = root.querySelector('[data-tcb-packages-empty]');
    var categoryFilter = root.querySelector('[data-tcb-browse-filter="category"]');
    var floorFilter = root.querySelector('[data-tcb-browse-filter="floor"]');
    var sizeFilter = root.querySelector('[data-tcb-browse-filter="size"]');
    var budgetFilter = root.querySelector('[data-tcb-browse-filter="budget"]');
    var sortFilter = root.querySelector('[data-tcb-browse-sort]');
    if (!catalogUrl || !grid) return;

    var state = cartState || {};
    state.category = state.category || 'all';
    state.floor = state.floor || 'all';
    state.size = state.size || 'all';
    state.budget = state.budget || 'all';
    state.sort = state.sort || 'menu';
    if (!state.catalog) state.catalog = null;
    if (!state.presets) state.presets = null;
    if (!state.items) state.items = [];

    function getFiltered() {
      var items = state.items.slice();
      if (state.category !== 'all') {
        items = items.filter(function (item) { return item.category === state.category; });
      }
      if (state.size !== 'all') {
        items = items.filter(function (item) {
          if (state.size === 'small') return item.category === 'starter';
          if (state.size === 'medium') return item.category === 'ready-made';
          if (state.size === 'large') return item.category === 'facility';
          return true;
        });
      }
      if (state.sort === 'name') {
        items.sort(function (a, b) { return a.title.localeCompare(b.title); });
      } else {
        items.sort(function (a, b) {
          return (a.menu_order || 99) - (b.menu_order || 99);
        });
      }
      return items;
    }

    function renderGrid() {
      var items = getFiltered();
      if (countEl) {
        countEl.textContent = 'Showing ' + items.length + ' package' + (items.length === 1 ? '' : 's');
      }
      if (!items.length) {
        grid.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      grid.innerHTML = items.map(function (item) {
        return renderBrowseCard(item, state.catalog.categories || []);
      }).join('');
    }

    function onFilterChange() {
      if (categoryFilter) state.category = categoryFilter.value || 'all';
      if (floorFilter) state.floor = floorFilter.value || 'all';
      if (sizeFilter) state.size = sizeFilter.value || 'all';
      if (budgetFilter) state.budget = budgetFilter.value || 'all';
      if (sortFilter) state.sort = sortFilter.value || 'menu';
      renderGrid();
    }

    if (categoryFilter) categoryFilter.addEventListener('change', onFilterChange);
    if (floorFilter) floorFilter.addEventListener('change', onFilterChange);
    if (sizeFilter) sizeFilter.addEventListener('change', onFilterChange);
    if (budgetFilter) budgetFilter.addEventListener('change', onFilterChange);
    if (sortFilter) sortFilter.addEventListener('change', onFilterChange);

    fetch(catalogUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        state.catalog = data;
        state.items = buildBrowseItems(data, shopProducts, preferCollection);
        renderGrid();
        if (presetsUrl) {
          return fetch(presetsUrl).then(function (res) { return res.json(); }).then(function (presets) {
            state.presets = presets;
          }).catch(function () {
  });
        }
      })
      .catch(function () {
        grid.innerHTML = '<p class="tcb-packages-loading">Unable to load packages.</p>';
      });
  }

  function initFinder(root, catalogUrl, shopProducts) {
    var form = root.querySelector('[data-tcb-packages-finder]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var facility = (form.querySelector('[name="facility"]') || {}).value;
      var goal = (form.querySelector('[name="goal"]') || {}).value;
      var ids = [];

      if (goal === 'startup') ids = FINDER_MAP.startup || [];
      else if (facility && FINDER_MAP[facility]) ids = FINDER_MAP[facility];

      loadPopular(root, catalogUrl, shopProducts, ids.length ? ids : null);

      var browse = document.getElementById('tcb-packages-browse');
      if (browse) {
        browse.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        var featured = document.getElementById('tcb-packages-featured');
        if (featured) featured.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function initVideoTrigger(root) {
    var trigger = root.querySelector('[data-tcb-packages-video-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      var finder = document.getElementById('tcb-packages-finder');
      if (finder) {
        finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (typeof window.tcbOpenTidioChat === 'function') {
        window.tcbOpenTidioChat();
      }
    });
  }

  function initLanding(section) {
    var catalogUrl = section.getAttribute('data-catalog-url');
    var presetsUrl = section.getAttribute('data-cart-presets-url');
    var shopProducts = readShopProducts(section);
    var preferCollection = section.hasAttribute('data-has-collection-products');
    var cartState = { catalog: null, presets: null, items: [] };

    initTabs(section);
    initFinder(section, catalogUrl, shopProducts);
    initVideoTrigger(section);
    initBrowse(section, catalogUrl, shopProducts, preferCollection, presetsUrl, cartState);
    loadPopular(section, catalogUrl, shopProducts, null);

    if (!section.getAttribute('data-tcb-catalog-add-bound')) {
      section.setAttribute('data-tcb-catalog-add-bound', '1');
      section.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-tcb-catalog-add]');
        if (!btn) return;
        event.preventDefault();
        quickAddCatalogPackage(cartState, btn.getAttribute('data-tcb-catalog-add'), btn, catalogUrl, presetsUrl);
      });
    }
  }

  function renderFaqList(host, faqs) {
    if (!host || !faqs || !faqs.length) return;
    host.innerHTML = faqs.map(function (f) {
      return (
        '<details class="tcb-packages-faq__item">' +
          '<summary>' + escapeHtml(f.q) + '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></summary>' +
          '<div class="tcb-packages-faq__answer rte"><p>' + escapeHtml(f.a) + '</p></div>' +
        '</details>'
      );
    }).join('');
    if (window.TcbFaqSchema) {
      var section = host.closest('[data-tcb-package-detail]');
      window.TcbFaqSchema.inject(host, faqs, section ? section.getAttribute('data-page-url') : window.location.href);
    }
  }

  function renderSpecs(host, rows) {
    if (!host || !rows || !rows.length) return;
    host.classList.remove('tcb-package-specs-placeholder');
    host.innerHTML =
      '<table class="tcb-package-specs-table"><tbody>' +
      rows.map(function (row) {
        return '<tr><th scope="row">' + escapeHtml(row.label) + '</th><td>' + escapeHtml(row.value) + '</td></tr>';
      }).join('') +
      '</tbody></table>';
  }

  var INCLUDED_CATEGORY_META = {
    core: { title: 'Core Equipment', icon: 'core' },
    chemicals: { title: 'Chemicals & Supplies', icon: 'chemicals' },
    safety: { title: 'Safety Essentials', icon: 'safety' },
    tools: { title: 'Tools & Accessories', icon: 'tools' },
    parts: { title: 'Parts & Maintenance', icon: 'parts' },
    support: { title: 'Expert Support Included', icon: 'docs' }
  };

  var INCLUDED_CATEGORY_ORDER = ['core', 'chemicals', 'safety', 'tools', 'parts', 'support'];

  var ALLOWED_ITEM_ROLES = {
    primary_machine: { label: 'Primary machine', bucket: 'core' },
    secondary_machine: { label: 'Secondary machine', bucket: 'core' },
    chemical: { label: 'Chemical', bucket: 'chemicals' },
    manual_cleaning_tool: { label: 'Manual cleaning tool', bucket: 'tools' },
    janitorial_cart: { label: 'Janitorial cart', bucket: 'tools' },
    accessory: { label: 'Accessory', bucket: 'tools' },
    safety: { label: 'Safety supply', bucket: 'safety' },
    ppe: { label: 'PPE', bucket: 'safety' },
    consumable: { label: 'Consumable', bucket: 'chemicals' },
    wear_part: { label: 'Wear part', bucket: 'parts' },
    replacement_part: { label: 'Replacement part', bucket: 'parts' },
    maintenance_supply: { label: 'Maintenance supply', bucket: 'parts' },
    optional_upgrade: { label: 'Optional upgrade', bucket: 'tools' }
  };

  var LEGACY_ROLE_MAP = {
    primary: 'primary_machine',
    main_machine: 'primary_machine',
    machine: 'primary_machine',
    core: 'primary_machine',
    secondary: 'secondary_machine',
    chemicals: 'chemical',
    chemical_set: 'chemical',
    tool: 'manual_cleaning_tool',
    tools: 'manual_cleaning_tool',
    cart: 'janitorial_cart',
    accessories: 'accessory',
    safety_supply: 'safety',
    parts: 'wear_part',
    maintenance: 'maintenance_supply',
    upgrade: 'optional_upgrade',
    optional: 'optional_upgrade'
  };

  var INCLUDED_LEGACY_GROUP_MAP = {
    machines: 'core',
    machine: 'core',
    equipment: 'core',
    chemicals: 'chemicals',
    chemical: 'chemicals',
    supplies: 'tools',
    supply: 'tools',
    accessories: 'tools',
    accessory: 'tools',
    parts: 'parts',
    part: 'parts',
    maintenance: 'parts',
    documentation: 'support',
    docs: 'support',
    planning: 'support'
  };

  function includedIconSvg(name) {
    var icons = {
      core: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="8" width="16" height="10" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M8 8V6a4 4 0 018 0v2" stroke="currentColor" stroke-width="1.8"/></svg>',
      chemicals: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 3h6l2 7H7l2-7zM8 10v8a2 2 0 002 2h4a2 2 0 002-2v-8" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
      safety: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3l8 4v6c0 4.5-3.5 8.5-8 9-4.5-.5-8-4.5-8-9V7l8-4z" stroke="currentColor" stroke-width="1.8"/><path d="M12 9v4M12 17h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      tools: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M14 6l4 4-6 6H8v-4l6-6z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
      parts: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      docs: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 4h10v16H7V4z" stroke="currentColor" stroke-width="1.8"/><path d="M9 8h6M9 12h6M9 16h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      box: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 8l8-4 8 4v8l-8 4-8-4V8z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
      building: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 20V8l7-4 7 4v12H5z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
      pencil: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 20h4l10-10-4-4L4 16v4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>'
    };
    return icons[name] || icons.docs;
  }

  function parseIncludedQty(text) {
    var match = String(text || '').match(/^(\d+)\s*[×x]\s*/i);
    return match ? parseInt(match[1], 10) : 1;
  }

  function stripIncludedQty(text) {
    return String(text || '').replace(/^\d+\s*[×x]\s*/i, '').trim();
  }

  function classifyIncludedLine(text) {
    var raw = String(text || '');
    var lower = stripIncludedQty(raw).toLowerCase();
    if (/vacuum|scrubber|extractor|burnisher|buffer|sweeper|floor machine|primary commercial machine|equipment category/.test(lower)) return 'core';
    if (/starter chemical|chemical set|disinfect|cleaner|odor control|degreaser|prespray|restroom cleaner|neutral cleaner/.test(lower)) return 'chemicals';
    if (/parts starter|filters, bags|squeegee blade|maintenance guide|equipment selection and maintenance/.test(lower)) return 'parts';
    if (/storage checklist|upgrade option|quote review|supply list|setup checklist|quote notes|startup checklist|first-account setup|expert support|freight|delivery planning|substitution/.test(lower)) return 'support';
    if (/^(\d+\s*[×x]\s*)?(wet floor sign|safety marker)/i.test(raw.trim())) return 'safety';
    if (/microfiber|housekeeping cart|janitorial cart|\bcart\b|sprayer|towel|cloth|\bppe\b|mop system|accessories|hose|wand|pad driver/.test(lower)) return 'tools';
    if (/wet floor sign|safety marker/.test(lower)) return 'safety';
    return 'tools';
  }

  function flattenIncludedItems(items) {
    if (!items || !items.length) return [];
    if (typeof items[0] === 'object' && items[0].group) {
      var flat = [];
      items.forEach(function (group) {
        (group.items || []).forEach(function (item) {
          flat.push(typeof item === 'string' ? item : String(item));
        });
      });
      return flat;
    }
    return items.map(function (item) { return String(item); });
  }

  function bucketIncludedItems(items) {
    var buckets = {};
    INCLUDED_CATEGORY_ORDER.forEach(function (key) {
      buckets[key] = { key: key, title: INCLUDED_CATEGORY_META[key].title, icon: INCLUDED_CATEGORY_META[key].icon, rows: [] };
    });

    if (typeof items[0] === 'object' && items[0].group) {
      items.forEach(function (group) {
        var groupKey = String(group.group || '').toLowerCase();
        var bucketKey = 'tools';
        Object.keys(INCLUDED_LEGACY_GROUP_MAP).some(function (token) {
          if (groupKey.indexOf(token) !== -1) {
            bucketKey = INCLUDED_LEGACY_GROUP_MAP[token];
            return true;
          }
          return false;
        });
        (group.items || []).forEach(function (item) {
          buckets[bucketKey].rows.push({ qty: 1, text: String(item) });
        });
      });
    } else {
      flattenIncludedItems(items).forEach(function (line) {
        var bucketKey = classifyIncludedLine(line);
        if (bucketKey === 'docs') bucketKey = 'support';
        buckets[bucketKey].rows.push({ qty: parseIncludedQty(line), text: stripIncludedQty(line) });
      });
    }

    return INCLUDED_CATEGORY_ORDER.map(function (key) { return buckets[key]; }).filter(function (bucket) {
      return bucket.rows.length > 0;
    });
  }

  function countIncludedItems(items) {
    return flattenIncludedItems(items).reduce(function (sum, line) {
      return sum + parseIncludedQty(line);
    }, 0);
  }

  function resolveIncludedOverviewImage(section, pageData, host) {
    var fallback = (host && host.getAttribute('data-included-overview-fallback')) || '';
    var heroImg = section.querySelector('[data-tcb-package-hero-img]');
    if (heroImg && heroImg.src && !heroImg.hidden) return heroImg.src;
    var sampleUrl = section.getAttribute('data-hero-asset-sample');
    var handle = section.getAttribute('data-page-handle');
    if (sampleUrl && pageData) {
      var candidates = heroCandidates(pageData, handle);
      if (candidates.length) return heroAssetUrl(sampleUrl, candidates[0]);
    }
    return fallback;
  }

  function setIncludedOverviewImage(section, url, altText) {
    var host = section.querySelector('[data-tcb-package-included]');
    if (!host || !url) return;
    var media = host.querySelector('.tcb-pkg-included-v3__overview-media');
    if (!media) return;
    var alt = altText || section.querySelector('h1')?.textContent || 'Package equipment overview';
    var existing = media.querySelector('img');
    if (existing) {
      existing.src = url;
      existing.alt = packageSeoAlt(alt, 'included');
      existing.hidden = false;
    } else {
      media.innerHTML = '<img src="' + escapeHtml(url) + '" alt="' + escapeHtml(packageSeoAlt(alt, 'included')) + '" loading="lazy" decoding="async" width="640" height="420">';
    }
    var placeholder = media.querySelector('.tcb-pkg-included-v3__overview-placeholder');
    if (placeholder) placeholder.remove();
  }

  function refreshIncludedOverviewImage(section, pageData, resolvedLines) {
    var host = section.querySelector('[data-tcb-package-included]');
    if (!host) return;
    var fallback = host.getAttribute('data-included-overview-fallback') || '';
    var sampleUrl = section.getAttribute('data-hero-asset-sample');
    var handle = section.getAttribute('data-page-handle');

    if (resolvedLines && resolvedLines.length) {
      var primary = resolvedLines.find(function (line) {
        return line.product && line.product.featured_image;
      }) || resolvedLines[0];
      if (primary && primary.product && primary.product.featured_image) {
        setIncludedOverviewImage(section, primary.product.featured_image);
        return;
      }
    }

    loadHeroImage(sampleUrl, heroCandidates(pageData, handle), function (url) {
      setIncludedOverviewImage(section, url);
    }, function () {
      if (fallback) setIncludedOverviewImage(section, fallback);
    });
  }

  function resolveIncludedOverviewCopy(pageData) {
    if (pageData && pageData.best_for) return pageData.best_for;
    if (pageData && pageData.hero_tagline) return pageData.hero_tagline;
    return 'Configured for hospitality, property, and day-to-day cleaning workflows.';
  }

  function renderIncludedRow(row) {
    var textHtml = row.url
      ? '<a class="tcb-pkg-included-v3__row-link" href="' + escapeHtml(row.url) + '">' + escapeHtml(row.text) + '</a>'
      : '<span class="tcb-pkg-included-v3__row-text">' + escapeHtml(row.text) + '</span>';
    var priceHtml = row.price
      ? '<span class="tcb-pkg-included-v3__row-price">' + escapeHtml(row.price) + '</span>'
      : '';
    return (
      '<div class="tcb-pkg-included-v3__row">' +
        '<span class="tcb-pkg-included-v3__qty">' + escapeHtml(String(row.qty)) + '×</span>' +
        '<div class="tcb-pkg-included-v3__row-copy">' + textHtml + priceHtml + '</div>' +
      '</div>'
    );
  }

  function renderIncluded(host, items, pageData, section) {
    if (!host) return;

    var hasCatalogItems = items && items.length;
    var heading = host.getAttribute('data-included-heading') || "What's included";
    var subtitle = host.getAttribute('data-included-subtitle') || 'Everything included in this package, organized by function so your team can review faster.';
    var quoteUrl = host.getAttribute('data-included-quote-url') || '#tcb-contact-form';
    var addLabel = host.getAttribute('data-included-add-label') || 'Add All to Cart';
    var expertLabel = host.getAttribute('data-included-expert-label') || 'Talk to an Expert';
    var quoteLabel = host.getAttribute('data-included-quote-label') || 'Request Custom Quote';
    var termsConfig = getPackageTermsConfig(host);
    var itemCount = hasCatalogItems ? countIncludedItems(items) : 0;
    var buckets = hasCatalogItems ? bucketIncludedItems(items) : [];
    var overviewFallback = host.getAttribute('data-included-overview-fallback') || '';
    var overviewCopy = resolveIncludedOverviewCopy(pageData);
    var checkoutLede = 'Add the predefined equipment and supplies for this package to your cart with one click. Then check out online in just a few steps, or request changes to tailor it to your needs.';

    var isHubPage = pageData && pageData.type === 'B';
    var waitingForStore = !hasCatalogItems && !isHubPage && !(host.getAttribute('data-included-resolved') === '1');
    var gridHtml = buckets.length
      ? renderIncludedGrid(buckets)
      : (isHubPage
        ? '<div class="tcb-pkg-included-v3__hub" role="status">' +
            '<p>This is a facility package hub. Browse the packages below for this facility type, or request a custom quote.</p>' +
            '<p><a class="tcb-page-btn tcb-page-btn--package" href="#tcb-package-highlights">See package options</a> ' +
            '<a class="tcb-page-btn tcb-page-btn--quote" href="' + escapeHtml(quoteUrl) + '">Request Custom Quote</a></p>' +
          '</div>'
        : (waitingForStore
          ? '<p class="tcb-pkg-included-v3__grid-loading" aria-live="polite">Loading store products…</p>'
          : '<p class="tcb-pkg-included-v3__grid-loading" aria-live="polite">Package contents will appear here once products are linked. <a href="' + escapeHtml(quoteUrl) + '">Request a custom quote</a>.</p>'));

    var prevHeight = host.offsetHeight;
    host.style.minHeight = Math.max(prevHeight, isHubPage ? 420 : 1100) + 'px';

    host.innerHTML =
      '<header class="tcb-pkg-included-v3__head">' +
        '<div class="tcb-pkg-included-v3__head-copy">' +
          '<h2 id="tcb-package-included-heading">' + escapeHtml(heading) + '</h2>' +
          '<p>' + escapeHtml(subtitle) + '</p>' +
        '</div>' +
        '<span class="tcb-pkg-included-v3__badge">' +
          includedIconSvg('box') +
          '<span>' + escapeHtml(hasCatalogItems ? (String(itemCount) + ' items included') : (isHubPage ? 'Facility hub' : (waitingForStore ? 'Loading package…' : 'Quote to customize'))) + '</span>' +
        '</span>' +
      '</header>' +
      '<div class="tcb-pkg-included-v3__layout">' +
        '<aside class="tcb-pkg-included-v3__overview">' +
          '<div class="tcb-pkg-included-v3__overview-head">Package Overview</div>' +
          '<div class="tcb-pkg-included-v3__overview-media">' +
            (overviewFallback
              ? '<img src="' + escapeHtml(overviewFallback) + '" alt="' + escapeHtml(packageSeoAlt((pageData && pageData.page_title) || heading, 'included')) + '" loading="lazy" decoding="async" width="640" height="420">'
              : '<span class="tcb-pkg-included-v3__overview-placeholder" aria-hidden="true"></span>') +
          '</div>' +
          '<p class="tcb-pkg-included-v3__disclaimer">Image for reference only. Actual items may vary.</p>' +
          '<p class="tcb-pkg-included-v3__overview-lede">' +
            includedIconSvg('building') +
            '<span><strong>Configured for your facility.</strong> ' + escapeHtml(overviewCopy) + '</span>' +
          '</p>' +
          '<ul class="tcb-pkg-included-v3__trust" role="list">' +
            '<li>Curated by cleaning experts</li>' +
            '<li>Quality brands you can trust</li>' +
            '<li>Built for reliability and long-term value</li>' +
          '</ul>' +
        '</aside>' +
        '<div class="tcb-pkg-included-v3__grid" role="list">' + gridHtml + '</div>' +
      '</div>' +
      '<div class="tcb-pkg-checkout-v4" data-tcb-package-included-checkout>' +
        '<div class="tcb-pkg-checkout-v4__intro">' +
          '<h3 class="tcb-pkg-checkout-v4__title">Ready to buy this package?</h3>' +
          '<p class="tcb-pkg-checkout-v4__lede" data-tcb-checkout-lede>' + escapeHtml(checkoutLede) + '</p>' +
          '<aside class="tcb-freight-review-notice tcb-freight-review-notice--compact tcb-freight-review-notice--package" role="note" aria-label="Quote &amp; Freight Reviewed Before Ship" data-tcb-freight-review-notice>' +
            '<span class="tcb-freight-review-notice__icon" aria-hidden="true">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M3 7h11v8H3V7zm11 2h4l3 3v3h-7V9z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="7" cy="17" r="2" stroke="currentColor" stroke-width="1.6"/><circle cx="17" cy="17" r="2" stroke="currentColor" stroke-width="1.6"/></svg>' +
            '</span>' +
            '<div class="tcb-freight-review-notice__copy">' +
              '<strong class="tcb-freight-review-notice__title">Quote &amp; Freight Reviewed Before Ship</strong>' +
              '<p class="tcb-freight-review-notice__body">We review delivery access, lift-gate needs, and accessory bundles before your order ships.</p>' +
            '</div>' +
          '</aside>' +
        '</div>' +
        '<div class="tcb-pkg-checkout-v4__panel">' +
          '<div class="tcb-pkg-checkout-v4__bundle" data-tcb-included-bundle hidden>' +
            '<h4 class="tcb-pkg-checkout-v4__bundle-title">Store products in this package</h4>' +
            '<div class="tcb-pkg-checkout-v4__flow" data-tcb-included-bundle-list role="list"></div>' +
          '</div>' +
          '<div class="tcb-pkg-checkout-v4__actions">' +
            '<button type="button" class="tcb-pkg-checkout-v4__btn tcb-pkg-checkout-v4__btn--primary" data-tcb-package-included-add disabled aria-busy="true">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6h15l-1.5 9h-12L6 6Z" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/><circle cx="9" cy="20" r="1.5" fill="currentColor"/><circle cx="18" cy="20" r="1.5" fill="currentColor"/><path d="M6 6 5 3H2" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>' +
              escapeHtml(addLabel) +
            '</button>' +
            '<div class="tcb-pkg-checkout-v4__total" data-tcb-package-total hidden>' +
              '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" fill="none" stroke="currentColor" stroke-width="1.75"/><circle cx="7" cy="7" r="1.5" fill="currentColor"/></svg>' +
              '<span>Package Total: <strong data-tcb-package-total-value></strong></span>' +
            '</div>' +
            '<a class="tcb-pkg-checkout-v4__btn tcb-pkg-checkout-v4__btn--secondary tcb-pkg-included-v3__quote-link" href="' + escapeHtml(quoteUrl) + '">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" fill="none" stroke="currentColor" stroke-width="1.75"/><path d="M14 2v6h6M8 13h8M8 17h5" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>' +
              escapeHtml(quoteLabel) +
            '</a>' +
            '<button type="button" class="tcb-pkg-checkout-v4__btn tcb-pkg-checkout-v4__btn--ghost tcb-package-hero__secondary-cta" data-tcb-tidio-chat>' +
              escapeHtml(expertLabel) +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<footer class="tcb-pkg-checkout-v4__customize tcb-pkg-included-v3__customize">' +
        '<div class="tcb-pkg-included-v3__customize-copy">' +
          includedIconSvg('box') +
          '<p><strong>Need substitutions or a fully custom package?</strong> Swap items, add accessories, or send us your exact list. We\'ll build a package that fits your facility.</p>' +
        '</div>' +
        '<div class="tcb-pkg-included-v3__customize-actions">' +
          '<button type="button" class="tcb-page-btn tcb-page-btn--secondary" data-tcb-package-customize-open>Add something else</button>' +
          '<a class="tcb-pkg-included-v3__customize-link" href="' + escapeHtml(quoteUrl) + '">Request custom quote →</a>' +
        '</div>' +
      '</footer>';

    if (section) setupPackageTermsGate(section);
  }

  function classifyProductBucket(product) {
    var text = String((product && product.title) || '').toLowerCase();
    var type = String((product && product.type) || '').toLowerCase();
    var tags = (product && product.tags ? String(product.tags) : '').toLowerCase();
    var hay = text + ' ' + type + ' ' + tags;
    if (/wet floor|safety sign|caution sign|a-frame sign/.test(hay)) return 'safety';
    if (/chemical|cleaner|degreaser|prespray|disinfect|odor|enzyme|neutralizer|soap|defoamer/.test(hay)) return 'chemicals';
    if (/filter|bag|belt|blade|maintenance kit|pad|part|maintenance|gasket|diaphragm|heater element|switch assembly/.test(hay)) return 'parts';
    if (/cart|microfiber|towel|cloth|sign|hose|wand|upholstery|hand tool|accessory|mop|squeegee/.test(hay)) return 'tools';
    if (/extractor|scrubber|burnisher|buffer|sweeper|floor machine|commercial vacuum|vacuum cleaner|air mover|dryer/.test(hay)) return 'core';
    if (/\bvacuum\b/.test(hay) && !/hose|protectant|filter|bag|motor|wand/.test(hay)) return 'core';
    return 'tools';
  }

  function bucketResolvedLines(resolvedLines) {
    var buckets = {};
    INCLUDED_CATEGORY_ORDER.forEach(function (key) {
      if (key === 'support') return;
      buckets[key] = {
        key: key,
        title: INCLUDED_CATEGORY_META[key].title,
        icon: INCLUDED_CATEGORY_META[key].icon,
        rows: []
      };
    });

    (resolvedLines || []).forEach(function (line) {
      var product = line.product || {};
      var bucketKey = roleBucket(line.role) || classifyProductBucket(product);
      var title = product.title || line.handle || 'Product';
      var url = product.url || (line.handle ? '/products/' + line.handle : '');
      var price = line.variant && line.variant.price != null ? formatMoney(line.variant.price) : '';
      buckets[bucketKey].rows.push({
        qty: line.quantity || 1,
        text: title,
        url: url,
        price: price
      });
    });

    var list = INCLUDED_CATEGORY_ORDER.filter(function (key) {
      return key !== 'support' && buckets[key] && buckets[key].rows.length;
    }).map(function (key) { return buckets[key]; });

    list.push({
      key: 'support',
      title: INCLUDED_CATEGORY_META.support.title,
      icon: INCLUDED_CATEGORY_META.support.icon,
      rows: [
        { qty: 1, text: 'Equipment sizing and floor-type fit review before you buy' },
        { qty: 1, text: 'Freight, liftgate, and delivery planning for large machines' },
        { qty: 1, text: 'Substitutions, upgrades, and custom quote support' }
      ]
    });

    return list;
  }

  function renderIncludedGrid(buckets) {
    return buckets.map(function (bucket) {
      return (
        '<article class="tcb-pkg-included-v3__card' + (bucket.key === 'support' ? ' tcb-pkg-included-v3__card--support' : '') + '">' +
          '<div class="tcb-pkg-included-v3__card-head">' +
            '<span class="tcb-pkg-included-v3__card-icon">' + includedIconSvg(bucket.icon) + '</span>' +
            '<h3 class="tcb-pkg-included-v3__card-title">' + escapeHtml(bucket.title) + '</h3>' +
          '</div>' +
          '<div class="tcb-pkg-included-v3__card-body">' +
            bucket.rows.map(renderIncludedRow).join('') +
          '</div>' +
        '</article>'
      );
    }).join('');
  }

  function syncIncludedGridFromCart(section, resolvedLines) {
    var host = section.querySelector('[data-tcb-package-included]');
    if (!host || !resolvedLines || !resolvedLines.length) return;

    var buckets = bucketResolvedLines(resolvedLines);
    var grid = host.querySelector('.tcb-pkg-included-v3__grid');
    if (grid) grid.innerHTML = renderIncludedGrid(buckets);

    host.classList.add('is-store-synced');

    var productCount = resolvedLines.reduce(function (sum, line) {
      return sum + (line.quantity || 1);
    }, 0);

    var badgeLabel = host.querySelector('.tcb-pkg-included-v3__badge span:last-child');
    if (badgeLabel) badgeLabel.textContent = productCount + ' store products included';

    var subtitle = host.querySelector('.tcb-pkg-included-v3__head-copy p');
    if (subtitle) {
      subtitle.textContent = 'Every item below is a real store product, grouped by function. Add All to Cart includes exactly these SKUs.';
    }

    var disclaimer = host.querySelector('.tcb-pkg-included-v3__disclaimer');
    if (disclaimer) {
      disclaimer.textContent = 'Product names and prices match the store items added to your cart.';
    }
  }

  function renderBundleProductCard(line, index, section) {
    var product = line.product || {};
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var title = product.title || line.handle || 'Product';
    var price = line.variant && line.variant.price != null ? formatMoney(line.variant.price) : '';
    var qty = line.quantity || 1;
    var productUrl = product.url || (line.handle ? '/products/' + line.handle : '');
    var lineKey = packageLineKey(line);
    var included = section && section.__tcbIncludedSelection
      ? !!section.__tcbIncludedSelection[lineKey]
      : true;
    var slotText = roleLabel(line.role);
    var slotLabel = slotText
      ? '<span class="tcb-pkg-checkout-v4__slot">' + escapeHtml(slotText) + '</span>'
      : '';
    var itemHtml =
      '<article class="tcb-pkg-checkout-v4__card' + (included ? '' : ' is-excluded') + '" role="listitem" data-tcb-bundle-card="' + escapeHtml(lineKey) + '">' +
        '<div class="tcb-pkg-checkout-v4__card-media">' +
          '<label class="tcb-pkg-checkout-v4__include" title="Include in package cart">' +
            '<input type="checkbox" data-tcb-included-item="' + escapeHtml(lineKey) + '"' + (included ? ' checked' : '') +
              ' aria-label="Include ' + escapeHtml(title) + ' in package cart">' +
            '<span class="tcb-pkg-checkout-v4__include-ui" aria-hidden="true"></span>' +
          '</label>' +
          '<span class="tcb-pkg-checkout-v4__card-qty">' + escapeHtml(String(qty)) + '×</span>' +
          (image
            ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(packageSeoAlt(title, 'bundle')) + '" loading="lazy" width="160" height="120" decoding="async">'
            : '<span class="tcb-pkg-checkout-v4__card-fallback" aria-hidden="true">📦</span>') +
        '</div>' +
        '<div class="tcb-pkg-checkout-v4__card-body">' +
          slotLabel +
          (productUrl
            ? '<a class="tcb-pkg-checkout-v4__card-name" href="' + escapeHtml(productUrl) + '">' + escapeHtml(title) + '</a>'
            : '<strong class="tcb-pkg-checkout-v4__card-name">' + escapeHtml(title) + '</strong>') +
          (price ? '<span class="tcb-pkg-checkout-v4__card-price">' + escapeHtml(price) + '</span>' : '') +
        '</div>' +
      '</article>';
    if (index === 0) return itemHtml;
    return '<span class="tcb-pkg-checkout-v4__plus" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 20 20"><path d="M10 4v12M4 10h12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg></span>' + itemHtml;
  }

  function enrichIncludedBundleList(section, resolvedLines) {
    var host = section.querySelector('[data-tcb-package-included]');
    var bundle = host && host.querySelector('[data-tcb-included-bundle]');
    var list = host && host.querySelector('[data-tcb-included-bundle-list]');
    var lines = (section && section.__tcbResolvedLines) || resolvedLines;
    if (!bundle || !list || !lines || !lines.length) return;

    list.innerHTML = lines.map(function (line, index) {
      return renderBundleProductCard(line, index, section);
    }).join('');
    bundle.hidden = false;
    bindBundleCardToggles(section);
  }

  function bindBundleCardToggles(section) {
    var list = section.querySelector('[data-tcb-included-bundle-list]');
    if (!list || list.getAttribute('data-tcb-bundle-bound') === '1') return;
    list.setAttribute('data-tcb-bundle-bound', '1');
    list.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches('[data-tcb-included-item]')) return;
      var key = input.getAttribute('data-tcb-included-item');
      if (!section.__tcbIncludedSelection) section.__tcbIncludedSelection = {};
      section.__tcbIncludedSelection[key] = input.checked;
      var card = input.closest('.tcb-pkg-checkout-v4__card');
      if (card) card.classList.toggle('is-excluded', !input.checked);
      refreshPackageItemSelection(section);
    });
  }

  function packageLineKey(line) {
    if (!line) return '';
    return String(line.id || line.handle || '');
  }

  function getPackagePickerMount(section) {
    return section.querySelector('.tcb-package-hero__frame') ||
      section.querySelector('.tcb-pkg-included-v3__overview-media');
  }

  function initPackageItemSelection(section, resolvedLines, packageTitle) {
    if (!section || !resolvedLines || !resolvedLines.length) return;
    section.__tcbResolvedLines = resolvedLines;
    section.__tcbPackageTitle = packageTitle || '';
    if (!section.__tcbIncludedSelection) section.__tcbIncludedSelection = {};
    resolvedLines.forEach(function (line) {
      var key = packageLineKey(line);
      if (key && section.__tcbIncludedSelection[key] === undefined) {
        section.__tcbIncludedSelection[key] = true;
      }
    });
    section.__tcbGetSelectedLines = function () {
      return (section.__tcbResolvedLines || []).filter(function (line) {
        return !!section.__tcbIncludedSelection[packageLineKey(line)];
      });
    };
  }

  function refreshPackageItemSelection(section) {
    if (!section || !section.__tcbGetSelectedLines) return;
    var lines = section.__tcbGetSelectedLines();
    var totalCents = lines.reduce(function (sum, line) {
      return sum + (line.variant.price * line.quantity);
    }, 0);
    var title = section.__tcbPackageTitle || section.querySelector('h1')?.textContent || '';

    updateCheckoutCopy(section, title, totalCents);

    var livePrice = totalCents ? ('From ' + formatMoney(totalCents)) : '';
    var stickyPrice = section.querySelector('[data-tcb-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = livePrice;

    var heroPrice = section.querySelector('[data-tcb-package-price]');
    if (heroPrice) {
      if (livePrice) {
        heroPrice.textContent = livePrice;
        heroPrice.hidden = false;
      } else {
        heroPrice.hidden = true;
      }
    }

    // Keep media/overview price chips in sync with the same live total.
    section.querySelectorAll('[data-tcb-package-media-price], [data-tcb-included-overview-price]').forEach(function (el) {
      if (livePrice) {
        el.textContent = livePrice;
        el.hidden = false;
      }
    });

    enrichIncludedBundleList(section, section.__tcbResolvedLines || lines);
    syncIncludedGridFromCart(section, lines);

    var badgeLabel = section.querySelector('.tcb-pkg-included-v3__badge span:last-child');
    if (badgeLabel) {
      badgeLabel.textContent = lines.length
        ? (lines.length + ' store product' + (lines.length === 1 ? '' : 's') + ' selected')
        : 'No items selected';
    }

    updatePackageCartButtons(section);
  }

  function renderPackageItemPicker(section) {
    var mount = getPackagePickerMount(section);
    if (mount) {
      var picker = mount.querySelector('[data-tcb-included-picker]');
      if (picker) picker.remove();
    }
  }

  function updateCheckoutCopy(section, packageTitle, totalCents) {
    var lede = section.querySelector('[data-tcb-checkout-lede]');
    if (lede && packageTitle) {
      lede.textContent =
        'Add the selected store products for ' +
        packageTitle +
        ' in one click. Prices below match the live cart total — request a quote if you need substitutions or freight planning.';
    }
    var totalWrap = section.querySelector('[data-tcb-package-total]');
    var totalValue = section.querySelector('[data-tcb-package-total-value]');
    if (totalWrap && totalValue) {
      if (totalCents) {
        totalValue.textContent = formatMoney(totalCents);
        totalWrap.hidden = false;
      } else {
        totalWrap.hidden = true;
      }
    }
  }

  function isPackageTermsAccepted() {
    return true;
  }

  function updatePackageCartButtons(section) {
    var cartReady = section.getAttribute('data-tcb-cart-ready') === '1';
    var selectedCount = section.__tcbGetSelectedLines ? section.__tcbGetSelectedLines().length : 1;
    section.querySelectorAll('[data-tcb-package-add-btn], [data-tcb-package-sticky-add], [data-tcb-package-included-add]').forEach(function (btn) {
      if (btn.hidden) return;
      if (btn.getAttribute('data-tcb-adding') === '1' || btn.getAttribute('aria-busy') === 'true') {
        btn.disabled = true;
        btn.classList.remove('is-terms-required');
        return;
      }
      btn.disabled = !cartReady || selectedCount === 0;
      btn.classList.remove('is-terms-required');
    });
  }

  function bindPackageTermsCheckboxes() {
    return;
  }

  function setupPackageTermsGate(section) {
    if (!section) return;

    if (section.getAttribute('data-tcb-terms-gate-bound') !== '1') {
      section.setAttribute('data-tcb-terms-gate-bound', '1');
      section.__tcbUpdateCartButtons = function () {
        updatePackageCartButtons(section);
      };
    }

    updatePackageCartButtons(section);
  }

  function requirePackageTerms() {
    return true;
  }

  var customizeProductsCache = null;

  function fetchAllShopProducts() {
    if (customizeProductsCache) return Promise.resolve(customizeProductsCache);
    var pages = [1, 2, 3, 4, 5];
    return Promise.all(
      pages.map(function (page) {
        return fetch('/products.json?limit=250&page=' + page)
          .then(function (res) { return res.ok ? res.json() : { products: [] }; })
          .catch(function () {
   return { products: [] }; });
      })
    ).then(function (results) {
      var seen = {};
      var products = [];
      results.forEach(function (payload) {
        (payload.products || []).forEach(function (product) {
          if (!product.handle || seen[product.handle]) return;
          seen[product.handle] = true;
          products.push(product);
        });
      });
      customizeProductsCache = products;
      return products;
    });
  }

  function setupCustomizeModal(section, packageTitle, quoteUrl) {
    var host = section.querySelector('[data-tcb-package-included]');
    var openBtn = host && host.querySelector('[data-tcb-package-customize-open]');
    if (!openBtn || openBtn.getAttribute('data-tcb-customize-bound') === '1') return;
    openBtn.setAttribute('data-tcb-customize-bound', '1');

    var modal = document.createElement('dialog');
    modal.className = 'tcb-pkg-customize-modal';
    modal.setAttribute('aria-labelledby', 'tcb-pkg-customize-title');
    modal.innerHTML =
      '<form method="dialog" class="tcb-pkg-customize-modal__panel">' +
        '<header class="tcb-pkg-customize-modal__head">' +
          '<div>' +
            '<h2 id="tcb-pkg-customize-title">Add something else</h2>' +
            '<p>Search store products to add alongside this package. Your cart keeps the predefined bundle — these are extras you choose.</p>' +
          '</div>' +
          '<button type="button" class="tcb-pkg-customize-modal__close" data-tcb-customize-close aria-label="Close">×</button>' +
        '</header>' +
        '<label class="tcb-pkg-customize-modal__search">' +
          '<span class="visually-hidden">Search products</span>' +
          '<input type="search" placeholder="Search machines, chemicals, accessories…" data-tcb-customize-search autocomplete="off">' +
        '</label>' +
        '<ul class="tcb-pkg-customize-modal__list" data-tcb-customize-list role="list"></ul>' +
        '<footer class="tcb-pkg-customize-modal__foot">' +
          '<a class="tcb-page-btn tcb-page-btn--secondary" href="' + escapeHtml(quoteUrl) + '">Request custom quote</a>' +
          '<button type="button" class="tcb-page-btn tcb-page-btn--primary" data-tcb-customize-close>Done</button>' +
        '</footer>' +
      '</form>';
    document.body.appendChild(modal);

    var list = modal.querySelector('[data-tcb-customize-list]');
    var search = modal.querySelector('[data-tcb-customize-search]');
    var allProducts = [];

    function renderCustomizeList(query) {
      var q = String(query || '').trim().toLowerCase();
      var matches = allProducts.filter(function (product) {
        if (!q) return true;
        return String(product.title || '').toLowerCase().indexOf(q) !== -1
          || String(product.product_type || '').toLowerCase().indexOf(q) !== -1
          || String(product.vendor || '').toLowerCase().indexOf(q) !== -1;
      }).slice(0, 40);

      if (!matches.length) {
        list.innerHTML = '<li class="tcb-pkg-customize-modal__empty">No matching products. Try another search or request a custom quote.</li>';
        return;
      }

      list.innerHTML = matches.map(function (product) {
        var image = product.images && product.images[0] ? product.images[0].src : '';
        var variant = (product.variants || []).find(function (v) { return v.available; }) || (product.variants || [])[0];
        var price = variant && variant.price ? formatStorefrontPrice(variant.price) : '';
        return (
          '<li class="tcb-pkg-customize-modal__item">' +
            (image
              ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(packageSeoAlt(product.title, 'bundle')) + '" loading="lazy" width="56" height="56" decoding="async">'
              : '<span class="tcb-pkg-customize-modal__thumb-fallback" aria-hidden="true">📦</span>') +
            '<div class="tcb-pkg-customize-modal__item-copy">' +
              '<strong>' + escapeHtml(product.title) + '</strong>' +
              (price ? '<span>' + escapeHtml(price) + '</span>' : '') +
            '</div>' +
            '<button type="button" class="tcb-page-btn tcb-page-btn--primary tcb-page-btn--compact" data-tcb-customize-add="' + escapeHtml(String(variant.id)) + '" data-tcb-customize-label="' + escapeHtml(product.title) + '">Add to cart</button>' +
          '</li>'
        );
      }).join('');
    }

    function bindCustomizeListActions() {
      list.querySelectorAll('[data-tcb-customize-add]').forEach(function (btn) {
        if (btn.getAttribute('data-tcb-bound') === '1') return;
        btn.setAttribute('data-tcb-bound', '1');
        var defaultLabel = btn.textContent.trim();
        btn.addEventListener('click', function () {
          var variantId = btn.getAttribute('data-tcb-customize-add');
          var label = btn.getAttribute('data-tcb-customize-label') || 'Extra item';
          btn.disabled = true;
          btn.textContent = 'Adding…';
          fetch(cartRoute('/cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(variantId),
                quantity: 1,
                properties: packageTitle ? { Package: packageTitle, 'Added via': 'Package customize' } : { 'Added via': 'Package customize' }
              }]
            })
          })
            .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
            .then(function (res) {
              if (!res.ok) throw res.data;
              refreshCartUi();
              btn.textContent = 'Added ✓';
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = defaultLabel;
              }, 1400);
            })
            .catch(function () {
              btn.textContent = 'Unavailable';
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = defaultLabel;
              }, 1800);
            });
        });
      });
    }

    function loadCustomizeProducts() {
      list.innerHTML = '<li class="tcb-pkg-customize-modal__empty">Loading products…</li>';
      return fetchAllShopProducts().then(function (products) {
        allProducts = products;
        renderCustomizeList(search.value);
        bindCustomizeListActions();
      });
    }

    openBtn.addEventListener('click', function () {
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', 'open');
      loadCustomizeProducts();
      if (search) search.focus();
    });

    modal.querySelectorAll('[data-tcb-customize-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        renderCustomizeList(search.value);
        bindCustomizeListActions();
      });
    }
  }

  function renderHighlights(host, highlights) {
    if (!host || !highlights || !highlights.length) return;
    host.innerHTML = highlights.map(function (highlight) {
      return (
        '<li class="tcb-package-highlight">' +
          '<strong>' + escapeHtml(highlight.title) + '</strong>' +
          '<span>' + escapeHtml(highlight.body) + '</span>' +
        '</li>'
      );
    }).join('');
  }

  function normalizePainPoints(items) {
    return (items || []).map(function (p) {
      return { title: p.title, text: p.body || p.text || '' };
    }).filter(function (p) { return p.title; });
  }

  var COLLECTION_FACILITY_MAP = {
    'contractor-cleaning-package': 'contractor',
    'warehouse-cleaning-package': 'warehouse',
    'school-church-package': 'school',
    'hotel-property-package': 'hotel',
    'healthcare-facility-package': 'healthcare',
    'starter-business-package': 'starter-business',
    'carpet-extractor-starter-package': 'carpet-extractor',
    'floor-scrubber-starter-package': 'floor-scrubber'
  };

  function inferFacilityId(pageData, packageId) {
    if (pageData && pageData.facility_id) return pageData.facility_id;
    if (packageId && COLLECTION_FACILITY_MAP[packageId]) return COLLECTION_FACILITY_MAP[packageId];
    return null;
  }

  function resolvePainSection(pageData, facilityCatalog, packageId) {
    if (!pageData && !packageId) return null;
    var painPoints = normalizePainPoints(pageData && pageData.pain_points);
    var heading = (pageData && pageData.pain_heading) || null;
    if (!painPoints.length) {
      var facilityId = inferFacilityId(pageData, packageId);
      if (facilityId && facilityCatalog) {
        var facility = (facilityCatalog.facilities || []).find(function (f) {
          return f.id === facilityId;
        });
        if (facility && facility.pain_points && facility.pain_points.length) {
          painPoints = facility.pain_points;
          heading = 'Common ' + (facility.short_title || 'Facility') + ' Cleaning Challenges We Solve';
        }
      }
    }
    if (!painPoints.length) return null;
    return { painPoints: painPoints, heading: heading };
  }

  function renderPainSection(section, painData) {
    if (!window.TcbPainChallenges) return;
    window.TcbPainChallenges.render({
      zone: section.querySelector('[data-tcb-package-pain-zone]'),
      grid: section.querySelector('[data-tcb-package-pain]'),
      headingEl: section.querySelector('[data-tcb-package-pain-heading]'),
      painPoints: painData ? painData.painPoints : null,
      heading: painData ? painData.heading : null,
      assetSample: section.getAttribute('data-hero-asset-sample'),
    });
  }

  function resolveBlueprint(blueprints, pageData, pageHandle) {
    if (!blueprints || !blueprints.by_package_id) return null;
    if (pageData && pageData.blueprint_id && blueprints.by_package_id[pageData.blueprint_id]) {
      return blueprints.by_package_id[pageData.blueprint_id];
    }
    if (pageData && pageData.id && blueprints.by_page_id && blueprints.by_page_id[pageData.id]) {
      return blueprints.by_package_id[blueprints.by_page_id[pageData.id]];
    }
    if (pageHandle && blueprints.by_page_handle && blueprints.by_page_handle[pageHandle]) {
      return blueprints.by_package_id[blueprints.by_page_handle[pageHandle]];
    }
    return null;
  }

  function mergeBlueprintPageData(pageData, blueprint) {
    if (!blueprint) return pageData;
    var merged = Object.assign({}, pageData || {});
    if (blueprint.included_groups && blueprint.included_groups.length) {
      merged.included_items = blueprint.included_groups;
    }
    merged.blueprint_id = blueprint.package_id;
    merged.blueprint_handle = blueprint.package_handle;
    merged.package_role = blueprint.metafields && blueprint.metafields.package_role;
    merged.facility_fit = blueprint.metafields && blueprint.metafields.facility_fit;
    merged.floor_type = blueprint.floor_type;
    merged.sds_review_required = blueprint.sds_review_required;
    merged.quote_required = blueprint.quote_required;
    if (blueprint.recommended_core_machine) merged.main_machine = blueprint.recommended_core_machine;
    if (blueprint.chemicals_to_include) merged.chemicals_preview = String(blueprint.chemicals_to_include).split(';').slice(0, 4).join(', ');
    if (blueprint.parts_consumables) merged.parts_included = String(blueprint.parts_consumables).split(';').slice(0, 4).join(', ');
    if (blueprint.tools_accessories) merged.supplies_preview = String(blueprint.tools_accessories).split(';').slice(0, 4).join(', ');
    return merged;
  }

  function applySdsReviewNotice(section, pageData) {
    if (!pageData || !pageData.sds_review_required) return;
    var host = section.querySelector('[data-tcb-package-included]');
    if (!host || host.querySelector('[data-tcb-sds-review-notice]')) return;
    var notice = document.createElement('p');
    notice.className = 'tcb-pkg-sds-notice';
    notice.setAttribute('data-tcb-sds-review-notice', '');
    notice.textContent = 'Chemical and disinfection items in this package require SDS/label review before publishing regulated claims.';
    host.insertBefore(notice, host.firstChild);
  }

  function renderFacilityHubFallback(section, pageData, facilityCatalog, pageHandle) {
    var host = section.querySelector('[data-tcb-package-included]');
    var highlights = section.querySelector('[data-tcb-package-highlights]');
    if (!facilityCatalog || !facilityCatalog.facilities) return;

    var facilityId = null;
    var facilityMap = {
      'school-cleaning-packages': 'school',
      'church-cleaning-packages': 'church',
      'gym-cleaning-packages': 'gym',
      'restaurant-cleaning-packages': 'restaurant',
      'warehouse-cleaning-packages': 'warehouse',
      'hotel-cleaning-packages': 'hotel',
      'property-manager-cleaning-packages': 'property-manager',
      'office-cleaning-packages': 'office',
      'healthcare-cleaning-packages': 'healthcare',
      'contractor-cleaning-packages': 'contractor',
      'starter-business-packages': 'starter-business',
      'carpet-extractor-packages': 'carpet-extractor',
      'floor-scrubber-packages': 'floor-scrubber'
    };
    facilityId = facilityMap[pageHandle] || null;
    var facility = (facilityCatalog.facilities || []).find(function (f) { return f.id === facilityId; });
    var subs = (facilityCatalog.sub_packages || []).filter(function (p) {
      return p.facility_id === facilityId;
    });
    if (!subs.length && facility && facility.packages) {
      subs = facility.packages;
    }

    var cards = (subs || []).slice(0, 12).map(function (pkg) {
      var handle = pkg.page_handle || pkg.handle || pkg.id;
      var href = handle
        ? (String(handle).indexOf('/pages/') === 0 ? handle : '/pages/' + handle)
        : '/pages/contact?topic=equipment-package';
      var title = pkg.title || pkg.name || handle || 'Package';
      var blurb = pkg.tagline || pkg.summary || pkg.best_for || 'View package details and add to cart.';
      return (
        '<a class="tcb-packages-card" href="' + escapeHtml(href) + '">' +
          '<div class="tcb-packages-card__body">' +
            '<h3>' + escapeHtml(title) + '</h3>' +
            '<p class="tcb-packages-card__meta">' + escapeHtml(blurb) + '</p>' +
            '<span class="tcb-packages-card__link">View Package →</span>' +
          '</div>' +
        '</a>'
      );
    }).join('');

    if (highlights && cards) {
      highlights.innerHTML =
        '<div class="tcb-packages-browse__grid" role="list">' + cards + '</div>';
    }
    if (host) {
      host.setAttribute('data-included-resolved', '1');
    }
    if (pageData && !pageData.included_items) {
      pageData.included_items = [];
    }
  }

  function applyMasterPage(section, pageData) {
    if (!pageData) return;
    var kicker = section.querySelector('[data-tcb-package-kicker]');
    var tagline = section.querySelector('[data-tcb-package-tagline]');
    var lead = section.querySelector('.tcb-package-hero__lead');
    var stickyPrice = section.querySelector('[data-tcb-sticky-price]');
    var heroPrice = section.querySelector('[data-tcb-package-price]');
    var ctaHeading = section.querySelector('.tcb-page-cta h2');
    var ctaText = section.querySelector('.tcb-page-cta p');
    var packageType = section.getAttribute('data-package-type');
    var isSubPackage = packageType === 'sub-package' || (pageData && pageData.type === 'D');

    if (kicker && pageData.kicker) kicker.textContent = pageData.kicker;
    if (tagline && (pageData.hero_tagline || pageData.best_for)) {
      tagline.textContent = pageData.hero_tagline || pageData.best_for;
    }
    if (lead && pageData.hero_lead) lead.innerHTML = pageData.hero_lead;
    // Tier marketing anchors are interim only. Once BOM lines resolve, refreshPackageItemSelection
    // overwrites hero/sticky/checkout with the same live total (one price truth).
    var hasLiveTotal = Boolean(section.__tcbGetSelectedLines && section.__tcbGetSelectedLines().length);
    if (!hasLiveTotal) {
      if (stickyPrice && pageData.price_display) stickyPrice.textContent = pageData.price_display;
      if (heroPrice && pageData.price_display) {
        heroPrice.textContent = pageData.price_display;
        heroPrice.hidden = false;
      }
    }
    if (ctaHeading && pageData.cta_heading) ctaHeading.textContent = pageData.cta_heading;
    if (ctaText && pageData.cta_body) ctaText.textContent = pageData.cta_body;

    if (isSubPackage) {
      var quotePrimary = section.querySelector('[data-tcb-package-quote-primary]');
      if (quotePrimary) quotePrimary.hidden = true;
    }

    renderHighlights(section.querySelector('[data-tcb-package-highlights]'), pageData.highlights);
    renderFaqList(section.querySelector('[data-tcb-package-faq]'), pageData.faq);
    renderSpecs(section.querySelector('[data-tcb-package-specs]'), pageData.specs_table);
    // Narrative included_items are not the commerce BOM; skip them when cart/items exist.
    var includedForDisplay = packageHasCommerceBom(pageData) ? null : pageData.included_items;
    renderIncluded(section.querySelector('[data-tcb-package-included]'), includedForDisplay, pageData, section);
    renderCompletePackageDescription(section, pageData);
    renderPackageProcedure(section, pageData);
    applySdsReviewNotice(section, pageData);
    refreshIncludedOverviewImage(section, pageData);
    applyDetailHeroImage(section, pageData);
    syncPackageVideoButton(section, pageData);
    bindPackageAnalytics(section, pageData);
    if (pageData && pageData.seo_title && typeof document !== 'undefined') {
      document.title = pageData.seo_title;
    }
    if (pageData && pageData.seo_description) {
      var metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute('content', pageData.seo_description);
    }
  }

  function resolveCompleteDescriptionRecord(pageData) {
    if (!pageData) return null;
    var content = pageData.content || {};
    var record = pageData.complete_package_description || content.complete_package_description || null;
    if (typeof record === 'string') {
      if (!record.trim()) return null;
      return { body: record };
    }
    if (!record || typeof record !== 'object') {
      if (content.complete_description && String(content.complete_description).trim()) {
        return { body: content.complete_description };
      }
      return null;
    }
    var hasStructured = [
      'what_this_package_is', 'who_this_package_is_for', 'where_it_works_best',
      'cleaning_problems', 'how_it_works_together', 'typical_workflow',
      'facility_and_surface', 'maintenance_and_consumables', 'when_to_choose_another',
      'when_to_upgrade', 'related'
    ].some(function (key) {
      var value = record[key];
      return value && (typeof value === 'string' ? value.trim() : (Array.isArray(value) ? value.length : true));
    });
    if (!hasStructured && !(record.body && String(record.body).trim())) return null;
    return record;
  }

  function cleanCompleteProse(value) {
    var text = String(value || '')
      .replace(/Configuration signature[\s\S]*?(?=\b(?:Keyword intent|Canonical commerce|No specialty|Price display|Zone coverage|Page identity)|$)/gi, '')
      .replace(/Keyword intent from the handle[\s\S]*?(?=\b(?:Canonical commerce|No specialty|Price display|Zone coverage|Page identity)|$)/gi, '')
      .replace(/Canonical commerce lines[\s\S]*?(?=\b(?:No specialty|Price display|Zone coverage|Page identity)|$)/gi, '')
      .replace(/No specialty badge[\s\S]*?(?=\b(?:Price display|Zone coverage|Page identity)|$)/gi, '')
      .replace(/Price display follows[\s\S]*?(?=\b(?:Zone coverage|Page identity)|$)/gi, '')
      .replace(/Zone coverage is implied[\s\S]*?(?=\b(?:Page identity)|$)/gi, '')
      .replace(/Page identity:\s*[a-z0-9-]+\.?/gi, '')
      .replace(/\b\d+\s*[×x]\s*[a-z0-9-]+(?:\s*\[[^\]]+\])?/gi, '')
      .replace(/\s*[|;]\s*/g, '. ')
      .replace(/\s+/g, ' ')
      .replace(/\.\s*\./g, '.')
      .replace(/\s+,/g, ',')
      .trim();
    return text.replace(/^\.+|\.+$/g, '').trim();
  }

  function clipWords(value, maxWords) {
    var text = cleanCompleteProse(value);
    if (!text) return '';
    var words = text.split(/\s+/);
    if (words.length <= maxWords) return text;
    return words.slice(0, maxWords).join(' ').replace(/[;,]+$/, '') + '…';
  }

  function completeIcon(name) {
    var icons = {
      package: '<path d="M3 7l5-3 5 3v7l-5 3-5-3V7z"/><path d="M8 4v14M3 7l5 3 5-3"/>',
      users: '<path d="M10 9a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"/><path d="M2.5 14c.6-1.7 2-2.8 4-2.8s3.4 1.1 4 2.8"/><path d="M12 8.2a2 2 0 1 0 0 3.2"/><path d="M13.8 14c.3-.9.9-1.6 1.7-2"/>',
      pin: '<path d="M8 14s5-4.2 5-7.2A5 5 0 0 0 3 6.8C3 9.8 8 14 8 14z"/><circle cx="8" cy="6.8" r="1.6"/>',
      alert: '<path d="M8 2.8 14 13H2L8 2.8z"/><path d="M8 6.5v3.2M8 11.4h.01"/>',
      flow: '<path d="M3 4h6v3H3zM7 9h6v3H7zM3 14h6v3H3z"/><path d="M6 7v2M10 12v2"/>',
      wrench: '<path d="M10.2 6.2a3 3 0 0 0-4 4L2.5 13.8 4.2 15.5l3.6-3.7a3 3 0 0 0 4-4l-1.8 1.8-1.8-1.8 1.8-1.8z"/>',
      spark: '<path d="M8 2.5 9.2 6.2 13 7.2l-2.8 2.3.8 3.8L8 11.4 5 13.3l.8-3.8L3 7.2l3.8-1L8 2.5z"/>'
    };
    return (
      '<span class="tcb-pkg-complete__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 16 16" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
          (icons[name] || icons.package) +
        '</svg>' +
      '</span>'
    );
  }

  function normalizeCompleteList(value) {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value.map(function (entry) {
        if (typeof entry === 'string') return cleanCompleteProse(entry);
        if (entry && typeof entry === 'object') {
          return cleanCompleteProse(entry.title || entry.body || entry.text || entry.url || '');
        }
        return '';
      }).filter(Boolean);
    }
    if (typeof value === 'object') {
      return Object.keys(value).map(function (key) {
        var text = cleanCompleteProse(value[key]);
        if (!text) return '';
        return key.replace(/_/g, ' ') + ': ' + text;
      }).filter(Boolean);
    }
    var text = cleanCompleteProse(value);
    if (!text) return [];
    return text.split(/(?<=\.)\s+/).map(function (part) { return part.trim(); }).filter(Boolean);
  }

  function prettyRoleLabel(key) {
    return String(key || '')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
  }

  function renderCompleteDescriptionBody(value) {
    if (!value) return '';
    if (Array.isArray(value)) {
      if (value.length && typeof value[0] === 'object' && value[0] && (value[0].title || value[0].url)) {
        var linkItems = value.filter(function (entry) { return entry && (entry.title || entry.url); });
        if (!linkItems.length) return '';
        return '<ul class="tcb-pkg-complete__links">' + linkItems.map(function (entry) {
          var label = entry.title || entry.url;
          if (entry.url) {
            return '<li><a href="' + escapeHtml(entry.url) + '">' + escapeHtml(label) + '</a></li>';
          }
          return '<li>' + escapeHtml(label) + '</li>';
        }).join('') + '</ul>';
      }
      var items = normalizeCompleteList(value);
      if (!items.length) return '';
      return '<ul>' + items.map(function (entry) {
        return '<li>' + escapeHtml(entry) + '</li>';
      }).join('') + '</ul>';
    }
    if (typeof value === 'object') {
      var parts = Object.keys(value).map(function (key) {
        var text = cleanCompleteProse(value[key]);
        if (!text) return '';
        return (
          '<div class="tcb-pkg-complete__role">' +
            '<span class="tcb-pkg-complete__role-label">' + escapeHtml(prettyRoleLabel(key)) + '</span>' +
            '<p>' + escapeHtml(text) + '</p>' +
          '</div>'
        );
      }).filter(Boolean);
      if (!parts.length) return '';
      return '<div class="tcb-pkg-complete__roles">' + parts.join('') + '</div>';
    }
    var text = cleanCompleteProse(value);
    if (!text) return '';
    return '<p>' + escapeHtml(text) + '</p>';
  }

  function renderCompleteDescriptionBlock(title, value, modifier) {
    var body = renderCompleteDescriptionBody(value);
    if (!body) return '';
    return (
      '<section class="tcb-pkg-complete__block' + (modifier ? ' tcb-pkg-complete__block--' + modifier : '') + '">' +
        '<h3>' + escapeHtml(title) + '</h3>' +
        body +
      '</section>'
    );
  }

  function renderCompleteDigestCard(title, text, iconName, modifier) {
    var body = clipWords(text, 30);
    if (!body) return '';
    return (
      '<article class="tcb-pkg-complete__card tcb-pkg-complete__card--' + escapeHtml(modifier || 'default') + '">' +
        '<div class="tcb-pkg-complete__card-top">' +
          completeIcon(iconName) +
          '<h3>' + escapeHtml(title) + '</h3>' +
        '</div>' +
        '<p>' + escapeHtml(body) + '</p>' +
      '</article>'
    );
  }

  function bindCompleteDescriptionToggle(host) {
    if (!host || host.getAttribute('data-tcb-complete-bound') === '1') return;
    var details = host.querySelector('[data-tcb-complete-more]');
    if (!details) return;
    host.setAttribute('data-tcb-complete-bound', '1');
    details.addEventListener('toggle', function () {
      var open = details.open;
      host.classList.toggle('is-expanded', open);
      try {
        if (window.TCBAnalytics && typeof window.TCBAnalytics.track === 'function') {
          window.TCBAnalytics.track(open ? 'package_complete_expand' : 'package_complete_collapse', {
            package_id: host.closest('[data-package-id]') && host.closest('[data-package-id]').getAttribute('data-package-id')
          });
        }
      } catch (err) { /* ignore */ }
    });
  }

  function renderCompletePackageDescription(section, pageData) {
    var host = section && section.querySelector('[data-tcb-package-complete-description]');
    if (!host) return;
    var record = resolveCompleteDescriptionRecord(pageData);
    if (!record) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }

    var title = (pageData && (pageData.page_title || pageData.title)) || 'This package';
    var what = record.what_this_package_is || record.body || '';
    var who = record.who_this_package_is_for || record.who_for || '';
    var where = record.where_it_works_best || record.where_best || '';
    var problems = normalizeCompleteList(record.cleaning_problems || record.challenges).slice(0, 3);
    var workflow = normalizeCompleteList(record.typical_workflow || (pageData.content && pageData.content.typical_workflow)).slice(0, 4);
    var together = clipWords(record.how_it_works_together, 34);

    var procedure = pageData.procedure || (pageData.content && pageData.content.procedure) || null;
    var bomItems = resolveProcedureBomItems(pageData) || [];
    var productLinkEntries = bomItems
      .map(function (item) {
        var handle = item.product_ref || item.handle || '';
        if (!handle) return null;
        return {
          title: (item.title || handle) + (item.role ? ' [' + item.role + ']' : ''),
          url: '/products/' + handle
        };
      })
      .filter(Boolean);

    function stepsAsText(steps) {
      if (!Array.isArray(steps) || !steps.length) return '';
      return steps
        .map(function (st) {
          var body = Array.isArray(st.instructions) ? st.instructions.join(' ') : st.objective || '';
          return (st.number ? st.number + '. ' : '') + (st.title || '') + (body ? ' — ' + body : '');
        })
        .join('\n');
    }

    var fullBlocks = [];
    // Wave 5 long-form CPD structure (CPD + approved procedure)
    fullBlocks.push(renderCompleteDescriptionBlock('1. Overview', what || record.body));
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '2. Before You Begin',
        (procedure && procedure.before_you_start) || who || 'Confirm facility route, floor type, and package contents before starting.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '3. Required PPE',
        'Wear hand protection when handling chemistry. Follow chemical labels and SDS. Use eye protection when splash risk is present.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '4. Safety & Area Preparation',
        (procedure && procedure.safety_rule_ids && procedure.safety_rule_ids.length
          ? 'Follow safety rules: ' + procedure.safety_rule_ids.join(', ') + '. '
          : '') +
          'Place wet-floor / caution signage before wet work. Isolate traffic until the floor is dry and safe.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '5. Equipment Inspection',
        'Inspect the primary machine, tanks, cords/batteries, and recovery path per the manufacturer manual before use.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '6. Machine Setup',
        record.role_guidance || record.how_it_works_together || 'Stage the primary machine from the package BOM and set controls for the floor condition.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '7. Working Media Setup',
        'Install the pad, brush, or accessory matched to the surface and soil. Do not substitute incompatible working media.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '8. Chemical Preparation',
        'Dose package chemistry using the product label and SDS. Never invent dilution ratios.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '9. Step-by-Step Cleaning Process',
        stepsAsText(procedure && procedure.steps) ||
          record.typical_workflow ||
          (pageData.content && pageData.content.typical_workflow),
        'workflow'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '10. Edge & Detail Cleaning',
        'Finish edges, corners, and secondary soils the primary machine cannot fully reach using package support tools.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '11. Recovery',
        'Recover solution as you work. Do not leave standing water in traffic paths. Empty and rinse recovery tanks per the machine manual.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '12. Inspection',
        (procedure && procedure.inspection && (procedure.inspection.summary || procedure.inspection.pass_criteria)) ||
          'Inspect for soil removal, streaks, and dry-down before reopening the zone.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '13. Return Area to Service',
        'Remove signage only when the floor is dry and safe. Restore furniture/traffic flow carefully.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '14. Machine Cleanup',
        (procedure && procedure.equipment_care && procedure.equipment_care.summary) ||
          'Rinse tanks, wipe exterior, and clear debris from pads/brushes after use.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '15. Post-Use Maintenance',
        record.maintenance_and_consumables ||
          (procedure && procedure.equipment_care) ||
          'Check wear parts and schedule replenishment before the next route.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '16. Common Mistakes',
        (procedure && procedure.common_mistakes) ||
          'Skipping signage, over-wetting, incompatible chemistry, or reopening before dry-down.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '17. Troubleshooting',
        (procedure && procedure.troubleshooting) ||
          'If results are weak, re-check pad/brush condition, dilution, solution flow, and recovery.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '18. Replacement Parts / Consumables',
        record.maintenance_and_consumables || 'Use TCB parts and consumables matched to the package machine.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '19. Reorder / Maintenance Recommendations',
        'Reorder chemistry, pads/brushes, and safety consumables from the package BOM. Use B2B replenishment where available.'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '20. Related Products',
        productLinkEntries.length ? productLinkEntries : record.related || 'See package What’s Included for linked TCB products.',
        'related'
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '21. Related Procedures',
        (procedure && procedure.title
          ? procedure.title + (procedure.summary ? ' — ' + procedure.summary : '')
          : 'See the on-page procedure section for the approved step workflow.')
      )
    );
    fullBlocks.push(
      renderCompleteDescriptionBlock(
        '22. Video Guide',
        (pageData.production && pageData.production.video_status === 'script_ready') ||
          (pageData.intelligence && pageData.intelligence.video && pageData.intelligence.video.pipeline && pageData.intelligence.video.pipeline.script_ready)
          ? 'A Creatify script is ready from this CPD and approved procedure. The rendered walkthrough appears in the package video player after QA publish.'
          : 'Package video publishes here after Creatify render and QA. Do not treat draft/library videos as package-ready.'
      )
    );
    // Preserve original CPD facets as appendix
    fullBlocks.push(renderCompleteDescriptionBlock('Appendix — Who This Package Is For', who));
    fullBlocks.push(renderCompleteDescriptionBlock('Appendix — Where It Works Best', where));
    fullBlocks.push(renderCompleteDescriptionBlock('Appendix — Cleaning Problems', record.cleaning_problems || record.challenges, 'problems'));
    fullBlocks.push(renderCompleteDescriptionBlock('Appendix — When to Choose Another Package', record.when_to_choose_another || record.not_for));
    fullBlocks.push(renderCompleteDescriptionBlock('Appendix — When to Upgrade', record.when_to_upgrade || record.alternatives_upgrade_guidance));
    var fullHtml = fullBlocks.filter(Boolean).join('');
    if (!fullHtml) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }

    var lead = clipWords(what || together || who, 28);
    var cards = [
      renderCompleteDigestCard('What it is', what, 'package', 'what'),
      renderCompleteDigestCard('Who it’s for', who, 'users', 'who'),
      renderCompleteDigestCard('Where it fits', where, 'pin', 'where')
    ].filter(Boolean).join('');

    var problemHtml = problems.length
      ? (
        '<div class="tcb-pkg-complete__problems">' +
          '<div class="tcb-pkg-complete__section-label">' + completeIcon('alert') + '<span>Problems this kit solves</span></div>' +
          '<ul>' + problems.map(function (item) {
            return '<li><span class="tcb-pkg-complete__bullet" aria-hidden="true"></span><span>' + escapeHtml(clipWords(item, 16)) + '</span></li>';
          }).join('') + '</ul>' +
        '</div>'
      )
      : '';

    var workflowHtml = workflow.length
      ? (
        '<div class="tcb-pkg-complete__workflow">' +
          '<div class="tcb-pkg-complete__section-label">' + completeIcon('flow') + '<span>How crews typically run it</span></div>' +
          '<ol>' + workflow.map(function (step, index) {
            return (
              '<li>' +
                '<span class="tcb-pkg-complete__step-num">' + (index + 1) + '</span>' +
                '<span>' + escapeHtml(clipWords(step, 15)) + '</span>' +
              '</li>'
            );
          }).join('') + '</ol>' +
        '</div>'
      )
      : '';

    var togetherHtml = together
      ? (
        '<div class="tcb-pkg-complete__together">' +
          completeIcon('spark') +
          '<p>' + escapeHtml(together) + '</p>' +
        '</div>'
      )
      : '';

    host.hidden = false;
    host.classList.add('tcb-pkg-complete-shell');
    host.innerHTML =
      '<header class="tcb-pkg-complete__head">' +
        '<p class="tcb-pkg-complete__eyebrow">Package guide</p>' +
        '<h2 id="tcb-package-complete-description-heading">Complete Package Description</h2>' +
        (lead ? '<p class="tcb-pkg-complete__lead">' + escapeHtml(lead) + '</p>' : '') +
        '<p class="tcb-pkg-complete__meta">A quick read first — open the full guide when you want every detail.</p>' +
      '</header>' +
      '<div class="tcb-pkg-complete__digest">' +
        (cards ? '<div class="tcb-pkg-complete__cards">' + cards + '</div>' : '') +
        problemHtml +
        togetherHtml +
        workflowHtml +
      '</div>' +
      '<details class="tcb-pkg-complete__more" data-tcb-complete-more>' +
        '<summary>' +
          '<span class="tcb-pkg-complete__more-label">' +
            '<span class="tcb-pkg-complete__more-closed">Read the full package guide</span>' +
            '<span class="tcb-pkg-complete__more-open">Hide full package guide</span>' +
          '</span>' +
          '<span class="tcb-pkg-complete__more-hint">Includes workflow, roles, upgrade paths, and related resources</span>' +
        '</summary>' +
        '<div class="tcb-pkg-complete tcb-pkg-complete--full">' +
          '<p class="tcb-pkg-complete__full-intro">Full guide for ' + escapeHtml(title) + '</p>' +
          fullHtml +
        '</div>' +
      '</details>';

    bindCompleteDescriptionToggle(host);
  }

  function resolveProcedureRecord(pageData) {
    if (!pageData) return null;
    var procedure = pageData.procedure || (pageData.content && pageData.content.procedure) || null;
    if (!procedure || typeof procedure !== 'object') return null;
    if (procedure.status !== 'approved' && procedure.status !== 'published') return null;
    if (!Array.isArray(procedure.steps) || procedure.steps.length < 3) return null;
    if (!procedure.title || !procedure.summary) return null;
    return procedure;
  }

  function resolveProcedureBomItems(pageData) {
    var requestedId = null;
    try {
      requestedId = new URLSearchParams(window.location.search).get('config');
    } catch (e) { /* ignore */ }
    return resolveCanonicalItemsFromPackage(pageData, requestedId)
      || pickFirstCanonicalItems(pageData && pageData.items, pageData && pageData.package_items, pageData && pageData.cart_items)
      || [];
  }

  function procedureProductsForRoles(items, roleRefs) {
    var roles = roleRefs || [];
    if (!roles.length) return [];
    var matched = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item) continue;
      if (roles.indexOf(item.role) !== -1 || roles.indexOf(item.product_role) !== -1) {
        matched.push(item);
      }
    }
    return matched;
  }

  function renderProcedureProductCards(items) {
    if (!items || !items.length) return '';
    return '<div class="tcb-procedure__products" data-tcb-procedure-products>' +
      items.map(function (item) {
        var handle = item.handle || item.product_ref || '';
        var label = handle ? handle.replace(/-/g, ' ') : (roleLabel(item.role) || 'Package item');
        var href = handle ? ('/products/' + encodeURIComponent(handle)) : '';
        return (
          '<article class="tcb-procedure__product">' +
            '<div>' +
              '<strong>' + escapeHtml(label) + '</strong>' +
              '<span>' + escapeHtml(roleLabel(item.role) || item.role || 'Included item') +
                (item.quantity ? ' · Qty ' + escapeHtml(String(item.quantity)) : '') +
              '</span>' +
            '</div>' +
            (href
              ? '<a class="tcb-procedure__commerce-only" href="' + href + '" data-tcb-procedure-product-link>View product</a>'
              : '') +
          '</article>'
        );
      }).join('') +
    '</div>';
  }

  function renderProcedureList(items) {
    if (!items || !items.length) return '';
    return '<ul>' + items.map(function (item) {
      return '<li>' + escapeHtml(item) + '</li>';
    }).join('') + '</ul>';
  }

  function renderPackageProcedure(section, pageData) {
    var host = section && section.querySelector('[data-tcb-package-procedure]');
    if (!host) return;
    var procedure = resolveProcedureRecord(pageData);
    if (!procedure) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }

    var bomItems = resolveProcedureBomItems(pageData);
    var toc = procedure.steps.map(function (step) {
      return '<li><a href="#tcb-procedure-step-' + step.number + '">' + escapeHtml(step.title) + '</a></li>';
    }).join('');

    var stepsHtml = procedure.steps.map(function (step) {
      var products = procedureProductsForRoles(bomItems, step.role_refs || step.slot_refs || []);
      return (
        '<article class="tcb-procedure__step" id="tcb-procedure-step-' + step.number + '">' +
          '<div class="tcb-procedure__step-heading">' +
            '<span class="tcb-procedure__step-number" aria-hidden="true">' + escapeHtml(String(step.number)) + '</span>' +
            '<div>' +
              '<h3>' + escapeHtml(step.title) + '</h3>' +
              (step.objective ? '<p class="tcb-procedure__objective">' + escapeHtml(step.objective) + '</p>' : '') +
            '</div>' +
          '</div>' +
          (Array.isArray(step.instructions) && step.instructions.length
            ? '<ol>' + step.instructions.map(function (line) { return '<li>' + escapeHtml(line) + '</li>'; }).join('') + '</ol>'
            : '') +
          renderProcedureProductCards(products) +
          (step.inspection_check
            ? '<div class="tcb-procedure__callout"><strong>Verify:</strong> ' + escapeHtml(step.inspection_check) + '</div>'
            : '') +
          (step.common_error
            ? '<div class="tcb-procedure__callout tcb-procedure__callout--error"><strong>Common mistake:</strong> ' + escapeHtml(step.common_error) + '</div>'
            : '') +
        '</article>'
      );
    }).join('');

    var safetyHtml = '';
    if (Array.isArray(procedure.safety_rule_ids) && procedure.safety_rule_ids.length) {
      safetyHtml =
        '<section class="tcb-procedure__panel tcb-procedure__safety" id="tcb-procedure-safety">' +
          '<h3>Safety requirements</h3>' +
          '<ul>' + procedure.safety_rule_ids.map(function (id) {
            return '<li>' + escapeHtml(String(id).replace(/_/g, ' ')) + '</li>';
          }).join('') + '</ul>' +
          '<div class="tcb-procedure__callout tcb-procedure__callout--safety">Follow the selected machine manual and chemical labels/SDS. Do not invent dilution or contact times.</div>' +
        '</section>';
    }

    var scheduleHtml = '';
    if (Array.isArray(procedure.schedule) && procedure.schedule.length) {
      scheduleHtml =
        '<section class="tcb-procedure__panel" id="tcb-procedure-schedule">' +
          '<h3>Cleaning schedule guidance</h3>' +
          procedure.schedule.map(function (entry) {
            return '<p><strong>' + escapeHtml(entry.frequency || 'Facility cadence') + '</strong></p>' +
              renderProcedureList(entry.tasks || []);
          }).join('') +
        '</section>';
    }

    var mistakesHtml = '';
    if (Array.isArray(procedure.common_mistakes) && procedure.common_mistakes.length) {
      mistakesHtml =
        '<section class="tcb-procedure__panel" id="tcb-procedure-mistakes">' +
          '<h3>Common mistakes</h3>' +
          '<ul>' + procedure.common_mistakes.map(function (m) {
            return '<li><strong>' + escapeHtml(m.title) + ':</strong> ' + escapeHtml(m.explanation) + '</li>';
          }).join('') + '</ul>' +
        '</section>';
    }

    var troubleHtml = '';
    if (Array.isArray(procedure.troubleshooting) && procedure.troubleshooting.length) {
      troubleHtml =
        '<section class="tcb-procedure__panel tcb-procedure__troubleshooting" id="tcb-procedure-troubleshooting">' +
          '<h3>Troubleshooting</h3>' +
          procedure.troubleshooting.map(function (t) {
            return '<div class="tcb-procedure__callout"><strong>' + escapeHtml(t.symptom) + '</strong>' +
              renderProcedureList(t.checks || []) + '</div>';
          }).join('') +
        '</section>';
    }

    var checklistItems = (procedure.checklist && procedure.checklist.items) || [];
    var checklistHtml =
      '<section class="tcb-procedure__panel tcb-procedure__checklist" id="tcb-procedure-checklist">' +
        '<h3>' + escapeHtml((procedure.checklist && procedure.checklist.title) || 'Printable checklist') + '</h3>' +
        renderProcedureList(checklistItems) +
        '<div class="tcb-procedure__checklist-actions tcb-procedure__commerce-only">' +
          '<button type="button" class="tcb-page-btn tcb-page-btn--secondary" data-tcb-procedure-print>Print checklist</button>' +
        '</div>' +
      '</section>';

    host.hidden = false;
    host.innerHTML =
      '<div class="tcb-procedure__shell tcb-procedure__shell--with-toc">' +
        '<nav class="tcb-procedure__toc" aria-label="Procedure sections">' +
          '<strong>On this procedure</strong>' +
          '<ol>' + toc +
            '<li><a href="#tcb-procedure-safety">Safety</a></li>' +
            '<li><a href="#tcb-procedure-inspection">Verify your work</a></li>' +
            '<li><a href="#tcb-procedure-checklist">Checklist</a></li>' +
          '</ol>' +
        '</nav>' +
        '<div class="tcb-procedure__main">' +
          '<header class="tcb-procedure__summary">' +
            '<p class="tcb-procedure__eyebrow">Complete cleaning procedure</p>' +
            '<h2 id="tcb-package-procedure-heading">' + escapeHtml(procedure.title) + '</h2>' +
            '<p class="tcb-procedure__summary-text">' + escapeHtml(procedure.summary) + '</p>' +
            '<ul class="tcb-procedure__meta" role="list">' +
              '<li><strong>Type</strong><span>' + escapeHtml((procedure.procedure_type || 'cleaning').replace(/_/g, ' ')) + '</span></li>' +
              '<li><strong>Crew</strong><span>' + escapeHtml(procedure.crew_text || 'Facility crew') + '</span></li>' +
              '<li><strong>Difficulty</strong><span>' + escapeHtml(procedure.difficulty || 'basic') + '</span></li>' +
              '<li><strong>Time</strong><span>' + escapeHtml(procedure.estimated_time_text || 'Varies by zone') + '</span></li>' +
            '</ul>' +
          '</header>' +
          (Array.isArray(procedure.before_you_start) && procedure.before_you_start.length
            ? '<section class="tcb-procedure__panel" id="tcb-procedure-before"><h3>Before you start</h3>' + renderProcedureList(procedure.before_you_start) + '</section>'
            : '') +
          '<section class="tcb-procedure__panel" id="tcb-procedure-products-needed">' +
            '<h3>Products used in this procedure</h3>' +
            '<p class="tcb-procedure__objective">Resolved from the currently approved package configuration BOM by role.</p>' +
            renderProcedureProductCards(bomItems) +
          '</section>' +
          stepsHtml +
          safetyHtml +
          scheduleHtml +
          '<section class="tcb-procedure__panel tcb-procedure__inspection" id="tcb-procedure-inspection">' +
            '<h3>Verify your work</h3>' +
            renderProcedureList(procedure.inspection || []) +
          '</section>' +
          mistakesHtml +
          troubleHtml +
          '<section class="tcb-procedure__panel tcb-procedure__maintenance" id="tcb-procedure-care">' +
            '<h3>After-cleaning equipment care</h3>' +
            renderProcedureList(procedure.equipment_care || []) +
          '</section>' +
          checklistHtml +
        '</div>' +
      '</div>';

    var printBtn = host.querySelector('[data-tcb-procedure-print]');
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        window.print();
      });
    }
  }

  function heroAssetUrl(sampleUrl, assetName) {
    if (!sampleUrl || !assetName) return '';
    var base = sampleUrl.indexOf('//') === 0 ? 'https:' + sampleUrl : sampleUrl;
    if (base.indexOf('package-hero-') !== -1) {
      return base.replace(/package-hero-[^/?#]+/, assetName);
    }
    return base.replace('package-hero-default.jpg', assetName);
  }

  function applyDetailHeroImage(section, pageData) {
    var sampleUrl = section.getAttribute('data-hero-asset-sample');
    var handle = section.getAttribute('data-page-handle');
    var img = section.querySelector('[data-tcb-package-hero-img]');
    var placeholder = section.querySelector('[data-tcb-package-hero-placeholder]');
    if (!img || !sampleUrl) return;

    loadHeroImage(sampleUrl, heroCandidates(pageData, handle), function (url) {
      if (img.getAttribute('src') !== url) img.src = url;
      img.alt = packageSeoAlt((pageData && pageData.page_title) || section.querySelector('h1')?.textContent, 'hero');
      img.hidden = false;
      if (placeholder) placeholder.hidden = true;
      var playBtn = section.querySelector('[data-tcb-package-video-trigger]');
      if (playBtn) {
        playBtn.hidden = false;
        syncPackageVideoButton(section, pageData);
      }
      refreshIncludedOverviewImage(section, pageData);
    }, function () {
      var playBtn = section.querySelector('[data-tcb-package-video-trigger]');
      if (playBtn) {
        playBtn.hidden = false;
        syncPackageVideoButton(section, pageData);
      }
      refreshIncludedOverviewImage(section, pageData);
    });
  }

  function syncPackageVideoButton(section, pageData) {
    var playBtn = section && section.querySelector('[data-tcb-package-video-trigger]');
    if (!playBtn) return;
    var video = resolvePackageVideo(pageData);
    playBtn.hidden = false;
    playBtn.setAttribute('data-tcb-video-provider', (video && video.provider) || 'creatify');
    playBtn.setAttribute('data-tcb-video-status', (video && video.status) || 'planned');
    playBtn.classList.toggle('is-ready', !!(video && video.ready));
    playBtn.classList.toggle('is-pending', !(video && video.ready));
    playBtn.setAttribute(
      'aria-label',
      (video && video.ready) ? 'Watch package walkthrough' : 'Package walkthrough coming soon'
    );
    if (video && video.url) playBtn.setAttribute('data-tcb-video-url', video.url);
    else playBtn.removeAttribute('data-tcb-video-url');
  }

  function heroCandidates(pageData, handle) {
    var list = [];
    if (pageData && pageData.hero_image_asset) list.push(pageData.hero_image_asset);
    if (pageData && pageData.hero_image_fallback) list.push(pageData.hero_image_fallback);
    if (handle) list.push('package-hero-' + handle + '.jpg');
    list.push('package-hero-default.jpg');
    return list.filter(function (item, index) { return list.indexOf(item) === index; });
  }

  function loadHeroImage(sampleUrl, candidates, onSuccess, onFail) {
    if (!candidates.length) {
      if (onFail) onFail();
      return;
    }
    var asset = candidates[0];
    var url = heroAssetUrl(sampleUrl, asset);
    if (!url) return loadHeroImage(sampleUrl, candidates.slice(1), onSuccess, onFail);
    var probe = new Image();
    probe.onload = function () { onSuccess(url, asset); };
    probe.onerror = function () { loadHeroImage(sampleUrl, candidates.slice(1), onSuccess, onFail); };
    probe.src = url;
  }

  function formatStorefrontPrice(value) {
    var num = Number(value);
    if (!num || isNaN(num)) return '';
    return '$' + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    return '$' + (Number(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function cartRoute(path) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + path;
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function fetchProductJson(handle, attempt) {
    attempt = attempt || 0;
    return fetch(cartRoute('/products/' + encodeURIComponent(handle) + '.js')).then(function (res) {
      if (res.status === 429 && attempt < 3) {
        return delay(350 + attempt * 250).then(function () {
          return fetchProductJson(handle, attempt + 1);
        });
      }
      if (!res.ok) throw new Error('missing product: ' + handle);
      return res.json();
    });
  }

  function resolveLineFromProduct(line, product) {
    var variant = null;
    if (line.variant_ref) {
      var wanted = String(line.variant_ref);
      variant = (product.variants || []).find(function (v) { return String(v.id) === wanted; }) || null;
    }
    if (!variant) {
      variant = (product.variants || []).find(function (v) { return v.available; }) || product.variants[0];
    }
    if (!variant || !variant.available) return null;
    return {
      id: variant.id,
      quantity: line.quantity || 1,
      product: product,
      variant: variant,
      handle: line.handle,
      role: line.role || '',
      required: !!line.required,
      included_by_default: line.included_by_default !== false,
      why_included: line.why_included || ''
    };
  }

  function resolveVariantLines(cartLines) {
    var MIN_BUNDLE_LINES = 1;
    var resolved = [];
    var chain = Promise.resolve();

    (cartLines || []).forEach(function (line) {
      if (!line || !line.handle) return;
      chain = chain.then(function () {
        return fetchProductJson(line.handle)
          .then(function (product) {
            var row = resolveLineFromProduct(line, product);
            if (row) resolved.push(row);
          })
          .catch(function () {
   /* skip missing/unavailable */ })
          .then(function () {
            return delay(100);
          });
      });
    });

    return chain.then(function () {
      if (resolved.length < MIN_BUNDLE_LINES) {
        throw new Error('insufficient bundle products');
      }
      return resolved;
    });
  }

  function normalizeItemRole(rawRole) {
    var role = String(rawRole || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
    if (!role) return '';
    if (ALLOWED_ITEM_ROLES[role]) return role;
    if (LEGACY_ROLE_MAP[role]) return LEGACY_ROLE_MAP[role];
    return '';
  }

  function inferItemRole(handle, index, machineCount) {
    var hay = String(handle || '').toLowerCase();
    if (/wet-floor|caution-sign|safety-sign|a-frame|glove|ppe|goggle|respirator/.test(hay)) {
      return /glove|ppe|goggle|respirator/.test(hay) ? 'ppe' : 'safety';
    }
    if (/cleaner|chemical|disinfect|degreaser|prespray|odor|enzyme|neutral|soap|defoamer|detergent/.test(hay)) {
      return 'chemical';
    }
    if (/janitorial-cart|housekeeping-cart|custodial-cart|\bcart\b/.test(hay)) return 'janitorial_cart';
    if (/filter|bag|belt|blade|pad|brush|gasket|diaphragm|maintenance-kit|wear/.test(hay)) {
      return /maintenance|kit/.test(hay) ? 'maintenance_supply' : 'wear_part';
    }
    if (/microfiber|mop|towel|cloth|sprayer|wand|hose|squeegee/.test(hay)) return 'manual_cleaning_tool';
    if (/scrubber|extractor|burnisher|buffer|sweeper|vacuum|floor-machine|air-mover|dryer/.test(hay)) {
      if (machineCount.count === 0) {
        machineCount.count += 1;
        return 'primary_machine';
      }
      machineCount.count += 1;
      return 'secondary_machine';
    }
    if (index === 0) return 'primary_machine';
    return 'accessory';
  }

  function normalizePackageItem(line, index, machineCount) {
    if (!line) return null;
    var raw = typeof line === 'string' ? { handle: line, quantity: 1 } : line;
    var handle = raw.handle || raw.product_handle || raw.product_ref || '';
    if (!handle && !raw.variant_id && !raw.id && !raw.variant_ref) return null;
    var role = normalizeItemRole(raw.role);
    if (!role) role = inferItemRole(handle || raw.title || '', index, machineCount);
    var includedByDefault = raw.included_by_default;
    if (includedByDefault == null) includedByDefault = role !== 'optional_upgrade';
    var required = raw.required;
    if (required == null) required = role === 'primary_machine' || includedByDefault;
    return {
      handle: handle || '',
      product_ref: raw.product_ref || handle || '',
      variant_ref: raw.variant_ref || raw.variant_id || raw.id || '',
      quantity: Number(raw.quantity || raw.qty || 1) || 1,
      role: role,
      required: !!required,
      included_by_default: !!includedByDefault,
      why_included: raw.why_included || ''
    };
  }

  function normalizeCanonicalItems(rawItems) {
    if (!rawItems || !rawItems.length) return null;
    var machineCount = { count: 0 };
    var items = [];
    for (var i = 0; i < rawItems.length; i++) {
      var item = normalizePackageItem(rawItems[i], i, machineCount);
      if (item) items.push(item);
    }
    return items.length ? items : null;
  }

  function pickFirstCanonicalItems() {
    for (var i = 0; i < arguments.length; i++) {
      var normalized = normalizeCanonicalItems(arguments[i]);
      if (normalized && normalized.length) return normalized;
    }
    return null;
  }

  function packageHasCommerceBom(pageData) {
    if (!pageData) return false;
    if (pageData.configurations && pageData.configurations.length) {
      var activeConfigs = getActiveConfigurations(pageData);
      if (activeConfigs.length) return true;
    }
    return !!(
      (pageData.items && pageData.items.length) ||
      (pageData.package_items && pageData.package_items.length) ||
      (pageData.cart_items && pageData.cart_items.length)
    );
  }

  function getActiveConfigurations(pkg) {
    if (!pkg || !Array.isArray(pkg.configurations)) return [];
    return pkg.configurations.filter(function (c) {
      return c && c.status !== 'retired' && c.status !== 'draft' && Array.isArray(c.items) && c.items.length;
    });
  }

  function resolveActiveConfiguration(pkg, requestedId) {
    if (!pkg) return null;
    var active = getActiveConfigurations(pkg);
    if (!active.length) return null;
    if (requestedId) {
      var requested = active.find(function (c) { return c.configuration_id === requestedId; });
      if (requested) return requested;
    }
    if (pkg.default_configuration_id) {
      var def = active.find(function (c) { return c.configuration_id === pkg.default_configuration_id; });
      if (def) return def;
    }
    var recommended = active.find(function (c) { return c.configuration_type === 'default_recommended'; });
    return recommended || active[0] || null;
  }

  function resolveCanonicalItemsFromPackage(pkg, requestedId) {
    if (!pkg) return null;
    var config = resolveActiveConfiguration(pkg, requestedId);
    if (config && Array.isArray(config.items) && config.items.length) {
      return normalizeCanonicalItems(config.items);
    }
    return pickFirstCanonicalItems(pkg.items, pkg.package_items, pkg.cart_items);
  }

  function readRequestedConfigurationId(section) {
    if (!section) return null;
    var attr = section.getAttribute('data-selected-configuration-id');
    if (attr) return attr;
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('config') || null;
    } catch (e) {
      return null;
    }
  }

  function applySelectedConfigurationMeta(section, pkg, config) {
    if (!section) return;
    if (pkg && pkg.package_family_id) {
      section.setAttribute('data-package-family-id', pkg.package_family_id);
    }
    if (config && config.configuration_id) {
      section.setAttribute('data-selected-configuration-id', config.configuration_id);
      section.setAttribute('data-package-configuration-id', config.configuration_id);
    }
  }

  function renderConfigurationSelector(section, pkg, onChange) {
    var host = section && section.querySelector('[data-tcb-package-config-selector]');
    if (!host) return;
    var active = getActiveConfigurations(pkg);
    if (active.length <= 1) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }
    var selectedId = readRequestedConfigurationId(section) || (pkg && pkg.default_configuration_id) || active[0].configuration_id;
    host.hidden = false;
    host.innerHTML =
      '<div class="tcb-package-config-selector">' +
        '<label class="tcb-package-config-selector__label" for="tcb-package-config-select">Configuration</label>' +
        '<select id="tcb-package-config-select" class="tcb-package-config-selector__select" data-tcb-package-config-select>' +
          active.map(function (c) {
            var selected = c.configuration_id === selectedId ? ' selected' : '';
            return '<option value="' + escapeHtml(c.configuration_id) + '"' + selected + '>' + escapeHtml(c.label || c.configuration_id) + '</option>';
          }).join('') +
        '</select>' +
      '</div>';
    var select = host.querySelector('[data-tcb-package-config-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var nextId = select.value;
      section.setAttribute('data-selected-configuration-id', nextId);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('config', nextId);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
      if (typeof onChange === 'function') onChange(nextId);
    });
  }

  function renderScoreSummary(section, config) {
    var host = section && section.querySelector('[data-tcb-package-score-summary]');
    if (!host) return;
    var fit = config && config.fit_score;
    var result = config && config.cleaning_result_score;
    var evidence = config && Array.isArray(config.score_evidence) ? config.score_evidence : [];
    var confidence = config && config.score_confidence;
    var canShow = (fit != null || result != null) && evidence.length && confidence && confidence !== 'unscored';
    if (!canShow) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }
    host.hidden = false;
    host.innerHTML =
      '<div class="tcb-package-score-summary">' +
        (fit != null ? '<p><strong>Package Fit Score:</strong> ' + escapeHtml(String(fit)) + '</p>' : '') +
        (result != null ? '<p><strong>Cleaning Result Score:</strong> ' + escapeHtml(String(result)) + '</p>' : '') +
        '<p class="tcb-package-score-summary__confidence">Confidence: ' + escapeHtml(confidence) + '</p>' +
      '</div>';
  }

  function findFacilitySubPackage(facilityCatalog, packageId, pageHandle) {
    if (!facilityCatalog || !facilityCatalog.sub_packages) return null;
    var subPkg = null;
    if (packageId) {
      subPkg = facilityCatalog.sub_packages.find(function (entry) { return entry.id === packageId; });
    }
    if (!subPkg && pageHandle) {
      subPkg = facilityCatalog.sub_packages.find(function (entry) {
        return entry.page_handle === pageHandle || entry.handle === pageHandle;
      });
    }
    return subPkg || null;
  }

  function roleBucket(role) {
    var meta = ALLOWED_ITEM_ROLES[normalizeItemRole(role)];
    return meta ? meta.bucket : '';
  }

  function roleLabel(role) {
    var meta = ALLOWED_ITEM_ROLES[normalizeItemRole(role)];
    return meta ? meta.label : '';
  }

  function normalizeCartLine(line) {
    if (!line) return null;
    var item = normalizePackageItem(line, 0, { count: 0 });
    if (!item || (!item.handle && !item.variant_ref)) return null;
    return {
      handle: item.handle,
      quantity: item.quantity,
      role: item.role,
      required: item.required,
      included_by_default: item.included_by_default,
      why_included: item.why_included,
      product_ref: item.product_ref,
      variant_ref: item.variant_ref
    };
  }

  function findCatalogPackage(catalog, packageId, pageHandle) {
    if (!catalog) return null;
    var pools = [];
    if (catalog.packages && catalog.packages.length) pools.push(catalog.packages);
    if (catalog.sub_packages && catalog.sub_packages.length) pools.push(catalog.sub_packages);
    if (!pools.length) return null;

    function matchIn(list) {
      if (packageId) {
        var byId = list.find(function (pkg) {
          return pkg.id === packageId
            || pkg.package_page_id === packageId
            || pkg.id + '-package' === packageId
            || packageId === pkg.id + '-package';
        });
        if (byId) return byId;
      }
      if (pageHandle) {
        return list.find(function (pkg) {
          return pkg.page_handle === pageHandle || pkg.handle === pageHandle;
        }) || null;
      }
      return null;
    }

    for (var i = 0; i < pools.length; i++) {
      var found = matchIn(pools[i]);
      if (found) return found;
    }
    return null;
  }

  function buildPackageKeys(packageId, pageData, catalogPackage, pageHandle) {
    var keys = [];
    function add(key) {
      if (!key || keys.indexOf(key) !== -1) return;
      keys.push(key);
    }
    add(packageId);
    if (pageData) {
      add(pageData.id);
      add(pageData.page_handle);
    }
    if (catalogPackage) {
      add(catalogPackage.id);
      add(catalogPackage.package_page_id);
    }
    add(pageHandle);
    if (pageHandle && pageHandle.indexOf('package-') === 0) {
      add(pageHandle.replace(/^package-/, '') + '-package');
      add(pageHandle.replace(/^package-/, ''));
    }
    return keys;
  }

  function lookupBundleHandles(presets, keys) {
    if (!presets) return null;
    var maps = [presets.package_overrides, presets.package_bundles];
    for (var m = 0; m < maps.length; m++) {
      var map = maps[m];
      if (!map) continue;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (key && map[key]) return map[key];
      }
    }
    return null;
  }

  function normalizeLinesList(raw) {
    return normalizeCanonicalItems(raw);
  }

  function resolveCartLinesFromPresets(presets, packageId, pageData, packageType, shopifyRef, facilityCatalog, catalogPackage, pageHandle, requestedConfigurationId) {
    if (!presets && !pageData && !shopifyRef && !catalogPackage && !facilityCatalog) return null;

    var keys = buildPackageKeys(packageId, pageData, catalogPackage, pageHandle);
    var subPkg = findFacilitySubPackage(facilityCatalog, packageId, pageHandle);

    // Pack 04: family → active/default configuration → config.items, then Pack 03 fallback.
    var fromPageConfig = resolveCanonicalItemsFromPackage(pageData, requestedConfigurationId);
    if (fromPageConfig && fromPageConfig.length) return fromPageConfig;
    var fromSubConfig = resolveCanonicalItemsFromPackage(subPkg, requestedConfigurationId);
    if (fromSubConfig && fromSubConfig.length) return fromSubConfig;
    var fromCatalogConfig = resolveCanonicalItemsFromPackage(catalogPackage, requestedConfigurationId);
    if (fromCatalogConfig && fromCatalogConfig.length) return fromCatalogConfig;

    // Canonical BOM priority: explicit items → cart_items → presets → single-product fallback.
    // Do not pick "longest list wins" across divergent display/cart sources.
    var canonical = pickFirstCanonicalItems(
      pageData && pageData.items,
      pageData && pageData.package_items,
      pageData && pageData.cart_items,
      subPkg && subPkg.items,
      subPkg && subPkg.package_items,
      subPkg && subPkg.cart_items,
      catalogPackage && catalogPackage.items,
      catalogPackage && catalogPackage.package_items,
      catalogPackage && catalogPackage.cart_items
    );
    if (canonical && canonical.length) return canonical;

    var bundleHandles = lookupBundleHandles(presets, keys);
    if (bundleHandles && bundleHandles.length) {
      var fromBundle = normalizeLinesList(bundleHandles.map(function (handle) {
        return { handle: handle, quantity: 1 };
      }));
      if (fromBundle) return fromBundle;
    }

    if (presets && presets.package_overrides) {
      for (var oi = 0; oi < keys.length; oi++) {
        var overrideKey = keys[oi];
        if (overrideKey && presets.package_overrides[overrideKey]) {
          var fromOverride = normalizeLinesList(presets.package_overrides[overrideKey].map(function (handle) {
            return { handle: handle, quantity: 1 };
          }));
          if (fromOverride) return fromOverride;
        }
      }
    }

    if (catalogPackage && catalogPackage.product_handle) {
      return normalizeLinesList([{ handle: catalogPackage.product_handle, quantity: 1, role: 'primary_machine' }]);
    }

    if (packageType === 'product' && shopifyRef) {
      return normalizeLinesList([{ handle: shopifyRef, quantity: 1, role: 'primary_machine' }]);
    }

    if (pageData && pageData.shopify_ref) {
      return normalizeLinesList([{ handle: pageData.shopify_ref, quantity: 1, role: 'primary_machine' }]);
    }

    if (pageData && pageData.facility_id && pageData.tier && presets) {
      var facilityMap = (presets.facility_tiers && presets.facility_tiers[pageData.facility_id]) || {};
      var handle = facilityMap[pageData.tier] || (presets.tier_defaults && presets.tier_defaults[pageData.tier]);
      if (handle) return normalizeLinesList([{ handle: handle, quantity: 1, role: 'primary_machine' }]);
    }

    return null;
  }

  function refreshCartUi() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
    document.dispatchEvent(new CustomEvent('tcb:cart-updated'));
    fetch(cartRoute('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        document.querySelectorAll('.header__cart-count, [data-tcb-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (el.hasAttribute('data-tcb-cart-count')) el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {
  });
  }

  function addResolvedLinesToCart(resolvedLines, packageTitle) {
    var payload = {
      items: resolvedLines.map(function (line) {
        return {
          id: line.id,
          quantity: line.quantity,
          properties: packageTitle ? { Package: packageTitle } : undefined
        };
      })
    };
    return fetch(cartRoute('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function bindPackageCartButton(section, button, resolvedLines, packageTitle, redirectToCart) {
    if (!button || button.getAttribute('data-tcb-package-bound') === '1') return;
    button.setAttribute('data-tcb-package-bound', '1');
    var defaultLabel = button.textContent.trim() || 'Add Package to Cart';

    button.addEventListener('click', function (event) {
      if (button.tagName === 'BUTTON' && button.getAttribute('type') !== 'button' && button.closest('form')) {
        return;
      }
      event.preventDefault();
      var linesToAdd = section.__tcbGetSelectedLines ? section.__tcbGetSelectedLines() : resolvedLines;
      if (!linesToAdd.length) return;
      button.setAttribute('data-tcb-adding', '1');
      button.disabled = true;
      button.textContent = 'Adding…';
      updatePackageCartButtons(section);

      var fullCount = (section.__tcbResolvedLines || resolvedLines || []).length;
      var isPartial = linesToAdd.length < fullCount;
      addResolvedLinesToCart(linesToAdd, packageTitle)
        .then(function () {
          var ctx = packageAnalyticsContext(section, section.__tcbPageData);
          if (window.tcbAnalytics) {
            window.tcbAnalytics.packageAddAllClicked(ctx.package_id, linesToAdd.length);
            if (isPartial && window.tcbAnalytics.packageAddIndividual) {
              window.tcbAnalytics.packageAddIndividual(Object.assign({}, ctx, { item_count: linesToAdd.length }));
            }
            if (window.tcbAnalytics.packageAddAllSuccess) {
              window.tcbAnalytics.packageAddAllSuccess(Object.assign({}, ctx, { item_count: linesToAdd.length }));
            }
          }
          refreshCartUi();
          button.textContent = 'Added ✓';
          if (redirectToCart !== false) {
            window.location.href = cartRoute('/cart');
            return;
          }
          setTimeout(function () {
            button.removeAttribute('data-tcb-adding');
            if (section.__tcbUpdateCartButtons) section.__tcbUpdateCartButtons();
            button.textContent = defaultLabel;
          }, 1600);
        })
        .catch(function () {
          if (window.tcbAnalytics && window.tcbAnalytics.packageAddAllFailed) {
            window.tcbAnalytics.packageAddAllFailed(packageAnalyticsContext(section, section.__tcbPageData));
          }
          button.textContent = 'Unavailable';
          setTimeout(function () {
            button.removeAttribute('data-tcb-adding');
            button.textContent = defaultLabel;
            if (section.__tcbUpdateCartButtons) section.__tcbUpdateCartButtons();
          }, 2200);
        });
    });
  }

  function bindLegacyProductForm(section, form, packageTitle) {
    if (!form || form.getAttribute('data-tcb-package-bound') === '1') return;
    form.setAttribute('data-tcb-package-bound', '1');
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var btn = form.querySelector('[data-tcb-package-add-btn], button[name="add"]');
      var defaultLabel = btn ? btn.textContent.trim() : 'Add Package to Cart';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }
      fetch(cartRoute('/cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) throw res.data;
          refreshCartUi();
          if (btn) btn.textContent = 'Added ✓';
          window.location.href = cartRoute('/cart');
        })
        .catch(function () {
          if (btn) {
            btn.textContent = 'Unavailable';
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = defaultLabel;
            }, 2200);
          }
        });
    });
  }

  function showQuoteOnlyFallback(section) {
    var addBtn = section.querySelector('[data-tcb-package-add-btn]');
    if (addBtn) addBtn.hidden = true;

    var quotePrimary = section.querySelector('[data-tcb-package-quote-primary]');
    if (quotePrimary) quotePrimary.hidden = false;

    // Avoid two identical quote CTAs in the hero row.
    var quoteLink = section.querySelector('[data-tcb-package-quote-link]');
    if (quoteLink) {
      if (quotePrimary) quoteLink.hidden = true;
      else quoteLink.hidden = false;
    }

    var stickyAdd = section.querySelector('[data-tcb-package-sticky-add]');
    if (stickyAdd) stickyAdd.hidden = true;

    var note = section.querySelector('[data-tcb-package-cart-note]');
    if (note) note.hidden = true;
  }

  function showPackageCartUi(section, packageTitle, totalCents) {
    var note = section.querySelector('[data-tcb-package-cart-note]');
    if (note) note.hidden = false;

    var quotePrimary = section.querySelector('[data-tcb-package-quote-primary]');
    if (quotePrimary) quotePrimary.hidden = true;

    var addBtn = section.querySelector('[data-tcb-package-add-btn]');
    if (addBtn) {
      addBtn.hidden = false;
      addBtn.removeAttribute('aria-busy');
    }

    section.setAttribute('data-tcb-cart-ready', '1');
    setupPackageTermsGate(section);

    var quoteLink = section.querySelector('[data-tcb-package-quote-link]');
    if (quoteLink) {
      quoteLink.hidden = false;
      if (!quoteLink.textContent.match(/custom/i)) {
        quoteLink.textContent = 'Request Custom Quote';
      }
    }

    var stickyAdd = section.querySelector('[data-tcb-package-sticky-add]');
    if (stickyAdd) stickyAdd.hidden = false;

    var stickyPrice = section.querySelector('[data-tcb-sticky-price]');
    if (stickyPrice && totalCents && !stickyPrice.textContent.trim()) {
      stickyPrice.textContent = formatMoney(totalCents);
    }

    var heroPrice = section.querySelector('[data-tcb-package-price]');
    if (heroPrice && totalCents) {
      heroPrice.textContent = 'From ' + formatMoney(totalCents);
      heroPrice.hidden = false;
    }
    updatePackageCartButtons(section);
  }

  function quickAddCatalogPackage(state, packageId, button, catalogUrl, presetsUrl) {
    function runAdd() {
      var section = button.closest('[data-tcb-package-detail]');
      var pageHandle = section ? section.getAttribute('data-page-handle') : null;
      var catalogPackage = findCatalogPackage(state.catalog, packageId, pageHandle);
      var cartLines = resolveCartLinesFromPresets(
        state.presets,
        packageId,
        null,
        catalogPackage && catalogPackage.type === 'product' ? 'product' : null,
        catalogPackage && catalogPackage.product_handle,
        null,
        catalogPackage,
        pageHandle
      );
      if (!cartLines || !cartLines.length) return Promise.reject(new Error('no cart lines'));

      var defaultLabel = button.textContent.trim() || 'Add Package to Cart';
      button.disabled = true;
      button.textContent = 'Adding…';

      return resolveVariantLines(cartLines)
        .then(function (resolvedLines) {
          return addResolvedLinesToCart(resolvedLines, catalogPackage ? catalogPackage.title : 'Equipment package');
        })
        .then(function () {
          refreshCartUi();
          button.textContent = 'Added ✓';
          window.location.href = cartRoute('/cart');
        })
        .catch(function () {
          button.textContent = 'Unavailable';
          setTimeout(function () {
            button.disabled = false;
            button.textContent = defaultLabel;
          }, 2200);
        });
    }

    if (state.catalog) return runAdd();

    var fetches = [];
    if (catalogUrl) {
      fetches.push(fetch(catalogUrl).then(function (res) { return res.json(); }).catch(function () {
   return null; }));
    } else {
      fetches.push(Promise.resolve(null));
    }
    if (presetsUrl && !state.presets) {
      fetches.push(fetch(presetsUrl).then(function (res) { return res.json(); }).catch(function () {
   return null; }));
    } else {
      fetches.push(Promise.resolve(state.presets));
    }

    return Promise.all(fetches).then(function (results) {
      state.catalog = results[0];
      if (results[1]) state.presets = results[1];
      return runAdd();
    });
  }

  function syncIncludedCheckoutUi(section, state) {
    var checkout = section.querySelector('[data-tcb-package-included-checkout]');
    var addBtn = section.querySelector('[data-tcb-package-included-add]');
    if (!checkout || !addBtn) return;

    if (state === 'ready') {
      section.setAttribute('data-tcb-cart-ready', '1');
      addBtn.hidden = false;
      addBtn.removeAttribute('aria-busy');
      checkout.classList.add('is-cart-ready');
      checkout.classList.remove('is-cart-unavailable');
      setupPackageTermsGate(section);
      updatePackageCartButtons(section);
      return;
    }

    if (state === 'unavailable') {
      section.removeAttribute('data-tcb-cart-ready');
      addBtn.hidden = true;
      addBtn.disabled = true;
      checkout.classList.remove('is-cart-ready');
      checkout.classList.add('is-cart-unavailable');
      return;
    }

    section.removeAttribute('data-tcb-cart-ready');
    addBtn.hidden = false;
    addBtn.disabled = true;
    addBtn.setAttribute('aria-busy', 'true');
    checkout.classList.remove('is-cart-ready', 'is-cart-unavailable');
  }

  function bindIncludedCartButton(section, resolvedLines, packageTitle) {
    var addBtn = section.querySelector('[data-tcb-package-included-add]');
    if (!addBtn || addBtn.getAttribute('data-tcb-package-bound') === '1') return;
    bindPackageCartButton(section, addBtn, resolvedLines, packageTitle, true);
  }

  function mountPackageCartButtons(section, resolvedLines, packageTitle, buttonLabel) {
    var primarySlot = section.querySelector('[data-tcb-package-primary-action]');
    if (primarySlot) {
      var quotePrimary = primarySlot.querySelector('[data-tcb-package-quote-primary]');
      var quotePrimaryHtml = quotePrimary ? quotePrimary.outerHTML : '';
      primarySlot.innerHTML =
        '<button type="button" class="tcb-page-btn tcb-page-btn--primary tcb-page-btn--navy" data-tcb-package-add-btn>' +
        escapeHtml(buttonLabel || 'Add Package to Cart') +
        '</button>' +
        quotePrimaryHtml;
      var mountedQuotePrimary = primarySlot.querySelector('[data-tcb-package-quote-primary]');
      if (mountedQuotePrimary) mountedQuotePrimary.hidden = true;
    }

    var addBtn = section.querySelector('[data-tcb-package-add-btn]');
    bindPackageCartButton(section, addBtn, resolvedLines, packageTitle, true);

    var stickyAdd = section.querySelector('[data-tcb-package-sticky-add]');
    if (stickyAdd) {
      stickyAdd.type = 'button';
      stickyAdd.hidden = false;
      stickyAdd.removeAttribute('form');
      bindPackageCartButton(section, stickyAdd, resolvedLines, packageTitle, true);
    }
  }

  function setupPackageCart(section, options) {
    var cartLines = options.cartLines;
    var packageTitle = options.packageTitle || section.querySelector('h1')?.textContent || 'Equipment package';
    var pageData = options.pageData || null;
    var quoteUrl = section.querySelector('[data-tcb-package-included]')?.getAttribute('data-included-quote-url') || '#tcb-contact-form';
    if (!cartLines || !cartLines.length) return;

    resolveVariantLines(cartLines)
      .then(function (resolvedLines) {
        var totalCents = resolvedLines.reduce(function (sum, line) {
          return sum + (line.variant.price * line.quantity);
        }, 0);
        showPackageCartUi(section, packageTitle, totalCents);
        mountPackageCartButtons(section, resolvedLines, packageTitle, options.buttonLabel);
        syncIncludedCheckoutUi(section, 'ready');
        initPackageItemSelection(section, resolvedLines, packageTitle);
        renderPackageItemPicker(section);
        bindIncludedCartButton(section, resolvedLines, packageTitle);
        enrichIncludedBundleList(section, section.__tcbResolvedLines);
        syncIncludedGridFromCart(section, section.__tcbGetSelectedLines());
        updateCheckoutCopy(section, packageTitle, totalCents);
        setupPackageTermsGate(section);
        refreshIncludedOverviewImage(section, pageData, resolvedLines);
        setupCustomizeModal(section, packageTitle, quoteUrl);
      })
      .catch(function () {
        showQuoteOnlyFallback(section);
        syncIncludedCheckoutUi(section, 'unavailable');
        refreshIncludedOverviewImage(section, pageData);
        setupCustomizeModal(section, packageTitle, quoteUrl);
      });
  }

  function bootstrapPackageCart(section, pageData, facilityCatalog, options) {
    var includedHost = section.querySelector('[data-tcb-package-included]');
    if (includedHost && !includedHost.querySelector('[data-tcb-package-included-checkout]')) {
      var includedForDisplay = packageHasCommerceBom(pageData) ? null : (pageData && pageData.included_items);
      renderIncluded(includedHost, includedForDisplay, pageData, section);
    }
    syncIncludedCheckoutUi(section, 'loading');
    var presetsUrl = section.getAttribute('data-cart-presets-url');
    var catalogUrl = section.getAttribute('data-catalog-url');
    var packageId = options.packageId;
    var packageType = options.packageType;
    var shopifyRef = options.shopifyRef;
    var shopButton = options.shopButton;

    function startCart(presets, catalog) {
      var pageHandle = section.getAttribute('data-page-handle');
      var catalogPackage = findCatalogPackage(catalog, packageId, pageHandle);
      var subPkg = findFacilitySubPackage(facilityCatalog, packageId, pageHandle);
      var familyPkg = pageData || subPkg || catalogPackage;
      var requestedConfigurationId = readRequestedConfigurationId(section);
      var activeConfig = resolveActiveConfiguration(familyPkg, requestedConfigurationId);
      applySelectedConfigurationMeta(section, familyPkg, activeConfig);
      renderConfigurationSelector(section, familyPkg, function () {
        // Atomic refresh of cart + included UI when configuration changes.
        startCart(presets, catalog);
        renderPackageProcedure(section, pageData || familyPkg);
      });
      renderScoreSummary(section, activeConfig);

      var cartLines = resolveCartLinesFromPresets(
        presets,
        packageId,
        pageData,
        packageType,
        shopifyRef || (catalogPackage && catalogPackage.product_handle),
        facilityCatalog,
        catalogPackage,
        pageHandle,
        requestedConfigurationId || (activeConfig && activeConfig.configuration_id)
      );
      if (!cartLines || !cartLines.length) {
        if (options.packageType === 'sub-package' || options.packageType === 'collection') {
          showQuoteOnlyFallback(section);
        }
        syncIncludedCheckoutUi(section, 'unavailable');
        return;
      }

      setupPackageCart(section, {
        cartLines: cartLines,
        packageTitle: (pageData && pageData.page_title) || (catalogPackage && catalogPackage.title) || section.querySelector('h1')?.textContent,
        buttonLabel: shopButton || (pageData && pageData.hero_cta) || 'Add Package to Cart',
        pageData: pageData
      });
    }

    var fetches = [];
    if (presetsUrl) {
      fetches.push(fetch(presetsUrl).then(function (res) { return res.json(); }).catch(function () {
   return null; }));
    } else {
      fetches.push(Promise.resolve(null));
    }
    if (catalogUrl) {
      fetches.push(fetch(catalogUrl).then(function (res) { return res.json(); }).catch(function () {
   return null; }));
    } else {
      fetches.push(Promise.resolve(null));
    }

    Promise.all(fetches).then(function (results) {
      startCart(results[0], results[1]);
    });
  }

  function initDetail(section) {
    var catalogUrl = section.getAttribute('data-catalog-url');
    var facilityCatalogUrl = section.getAttribute('data-facility-catalog-url');
    var masterUrl = section.getAttribute('data-master-url');
    var pageHandle = section.getAttribute('data-page-handle');
    var packageId = section.getAttribute('data-package-id');
    var packageType = section.getAttribute('data-package-type');
    var shopifyRef = section.getAttribute('data-shopify-ref');
    var shopButton = section.getAttribute('data-shop-button') || 'Add Package to Cart';
    if (!packageId && !pageHandle) return;

    var kicker = section.querySelector('[data-tcb-package-kicker]');
    var tagline = section.querySelector('[data-tcb-package-tagline]');
    var sticky = section.querySelector('[data-tcb-package-sticky]');
    var stickyPrice = section.querySelector('[data-tcb-sticky-price]');
    var hero = section.querySelector('.tcb-package-hero');

    if (hero && sticky) {
      var obs = new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting;
      }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
      obs.observe(hero);
    }

    if (masterUrl && pageHandle) {
      var blueprintsUrl = section.getAttribute('data-blueprints-url');
      var fetches = [fetch(masterUrl).then(function (res) { return res.json(); })];
      if (facilityCatalogUrl) {
        fetches.push(fetch(facilityCatalogUrl).then(function (res) { return res.json(); }).catch(function () {
   return null; }));
      } else {
        fetches.push(Promise.resolve(null));
      }
      if (blueprintsUrl) {
        fetches.push(fetch(blueprintsUrl).then(function (res) { return res.json(); }).catch(function () {
   return null; }));
      } else {
        fetches.push(Promise.resolve(null));
      }

      Promise.all(fetches)
        .then(function (results) {
          var master = results[0];
          var facilityCatalog = results[1];
          var blueprints = results[2];
          var pageData = master.pages_by_handle && master.pages_by_handle[pageHandle];
          var blueprint = resolveBlueprint(blueprints, pageData, pageHandle);
          pageData = mergeBlueprintPageData(pageData, blueprint);
          // Type B hubs belong on the facility-hub template; keep detail usable if mis-assigned.
          if (pageData && pageData.type === 'B') {
            section.setAttribute('data-tcb-commerce-skip', '1');
            renderFacilityHubFallback(section, pageData, facilityCatalog, pageHandle);
          }
          applyMasterPage(section, pageData);
          renderPainSection(section, resolvePainSection(pageData, facilityCatalog, packageId));
          if (section.getAttribute('data-tcb-commerce-skip') !== '1') {
            bootstrapPackageCart(section, pageData, facilityCatalog, {
              packageId: packageId,
              packageType: packageType,
              shopifyRef: shopifyRef || (pageData && pageData.shopify_ref),
              shopButton: shopButton
            });
          }
        })
        .catch(function () {
          if (section.getAttribute('data-tcb-commerce-skip') !== '1') {
            bootstrapPackageCart(section, null, null, {
              packageId: packageId,
              packageType: packageType,
              shopifyRef: shopifyRef,
              shopButton: shopButton
            });
          }
        });
    } else if (section.getAttribute('data-tcb-commerce-skip') !== '1') {
      bootstrapPackageCart(section, null, null, {
        packageId: packageId,
        packageType: packageType,
        shopifyRef: shopifyRef,
        shopButton: shopButton
      });
    }

    fetch(catalogUrl || '/cdn/shop/t/1/assets/packages-catalog.json')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var pkg = (data.packages || []).find(function (p) { return p.id === packageId; });
        if (!pkg) return;
        var cat = (data.categories || []).find(function (c) { return c.id === pkg.category; });
        if (kicker && cat) kicker.textContent = cat.label;
        if (tagline && pkg.tagline) tagline.textContent = pkg.tagline;
      })
      .catch(function () {
   /* non-critical */ });
  }

  function initSection(section) {
    if (section.hasAttribute('data-tcb-packages-landing')) {
      initLanding(section);
    }
    if (section.hasAttribute('data-tcb-package-detail')) {
      initDetail(section);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tcb-packages-landing], [data-tcb-package-detail]').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-tcb-packages-landing], [data-tcb-package-detail]');
    if (section) initSection(section);
  });
})();
